/* eslint-disable max-len */

export default {
  errors: {
    global: {
      internal: 'आंतरिक त्रुटि',
      not_allowed: 'कार्रवाई की अनुमति नहीं है',
      access_denied: 'पहुंच अस्वीकृत',
      validator_error: 'सत्यापनकर्ता त्रुटि {details}',
      wrong_body: 'ग़लत शरीर',
      wrong_token: 'ग़लत टोकन',
      missing_token: 'टोकन गायब है',
      exclusive_lock: 'विशेष ताला',
      access_denied_acl: 'प्रवेश निषेध (ACL)',
      connection_timeout: 'वाईफ़ाई कनेक्शन टाइमआउट',
      login_required: 'लॉगिन आवश्यक',
      not_found: 'नहीं मिला',
      wrong_value: 'गलत मूल्य',
      token_expired: 'टोकन समाप्त हो गया',
      service_not_available: 'सेवा उपलब्ध नहीं है',
      twofa_required: '2FA प्रमाणीकरण आवश्यक है',
      missing_login_token: 'लॉगिन आवश्यक',
    },
    account: {
      banned: 'खाते पर प्रतिबंध लगा दिया',
      wrong_login_or_password: 'गलत लॉगिन और पासवर्ड',
      wrong_login: 'गलत लोगिन',
      wrong_password: 'password galat hai',
      blocked: 'खाता ब्लॉक कर दिया गया',
      missing_email: 'ईमेल पता निर्दिष्ट नहीं किया गया',
      same_password_used: 'वही पासवर्ड इस्तेमाल किया गया',
      apikey_not_created: 'API कीय नहीं बना है',
      apikey_already_created: 'API कीय पहले से बना है',
      twofa_not_created: '2FA नहीं बना है',
      twofa_already_created: '2FA पहले से बना है',
      deletion_already_started: 'खाता हटाना पहले ही शुरू हो चुका है',
      wrong_twofa: '2FA गलत है',
      external_withdraw_not_available: 'बाहरी निकासी उपलब्ध नहीं है',
      twofa_limit: '2FA सीमा',
      kyc_wrong_step: 'KYC गलत कदम',
      not_exists: 'अस्तित्व में नहीं है',
      kyc_required: 'KYC आवश्यक',
      action_not_allowed: 'कार्रवाई की अनुमति नहीं है',
      migration: 'प्रवास',
      wrong_password_pattern: 'पासवर्ड में 8 से 64 अक्षर और कम से कम एक होना चाहिए: अपरकेस, लोअरकेस, संख्या, विशेष',
    },
    market: {
      not_enough_funds: 'पर्याप्त फंड नहीं हैं',
      missing_steam_token: 'स्ट्रीम का ट्रेडिंग URL नहीं मिल रहा है',
      missing_steam_id: 'स्टीम ईद नहीं मिला',
      wrong_item_status: 'ग़लत आइटम स्थिति',
      item_already_queued: 'आइटम पहले से ही कतारबद्ध है',
      max_price_limit: 'अधिकतम कीमत सीमा',
      item_not_available: 'आइटम उपलब्ध नहीं है',
      steam_vac_ban: 'स्टीम VAC प्रतिबन्ध',
      steam_trade_ban: 'स्टीम व्यापार पर प्रतिबंध',
      steam_private_profile: 'निजी प्रोफ़ाइल स्टीम करें',
      steam_private_inventory: 'स्टीम इन्वेंटरी प्राइवेट है',
      steam_tradehold: 'स्टीम ट्रेडिंग रुकी हुई है',
      cannot_check_tradeban: 'व्यापार प्रतिबंधों की जांच नहीं कर सकते',
      cannot_check_tradehold: 'ट्रेड होल्ड की जाँच नहीं कर सकते',
      wrong_steam_token: 'स्टीम टोकन गलत है',
      no_items_found: 'कुछ भी नहीं है',
      items_limit: 'वस्तुओं की सीमा',
      instant_sell_disabled: 'तत्काल बिक्री अक्षम',
      plan_not_found: 'योजना नहीं मिली',
      price_too_low: 'कीमत बेहुत कम है',
    },
    steam: {
      wrong_tradelink: 'गलत ट्रेड लिंक',
      private_inventory: 'स्टीम इन्वेंटरी निजी है',
      cannot_check_tradeban: 'हम व्यापार प्रतिबंध की जाँच नहीं कर सकते',
      cannot_check_tradehold: 'हम ट्रेड होल्ड की जाँच नहीं कर सकते',
      vac_ban: 'VAC प्रतिबंध',
      trade_ban: 'व्यापार प्रतिबंध',
      private_profile: 'निजी स्टीम प्रोफ़ाइल',
      tradehold: 'व्यापार रोकें',
      wrong_token: 'गलत टोकन',
      missing_token: 'स्ट्रीम का ट्रेडिंग URL नहीं मिल रहा है',
      missing_steam_id: 'स्टीम आईडी गायब है',
      community_ban: 'कम्युनियत प्रतिबन्ध',
      economy_ban: 'इकॉनमी प्रतिबन्ध',
      platform_offline: 'स्टीम से कोई संबंध नहीं, सर्वर डाउन हो सकते हैं। कृपया बाद में पुन: प्रयास करें।',
      cannot_check_escrow: 'एस्क्रो की जाँच नहीं कर सकते',
      escrow: 'आप ईमेल स्टीम गार्ड का उपयोग कर रहे हैं जो हमारे बॉट्स के साथ व्यापार करने के लिए पर्याप्त नहीं है। हमारे बॉट्स के साथ व्यापार करने में सक्षम होने के लिए आपके पास सक्रिय मोबाइल स्टीम गार्ड होना चाहिए।',
      fresh_account: 'आपको पहले स्टीम प्रोफाइल सेटअप करना होगा',
    },
    mutex: {
      long_lock: 'लंबा लॉक, {ttl} सेकंड में पुनः प्रयास करें',
      exclusive_lock: 'विशेष ताला',
    },
    api: {
      missing_apikey: 'API चाबी गुम है',
      missing_secret: 'गुम API रहस्य',
      wrong_ip_address: 'गलत IP पता',
      private_ip_address: 'निजी IP पता',
      wrong_apikey: 'API चाबे गलत है',
    },
    record: {
      item_not_found: 'आइटम नहीं मिला',
      item_not_owned: 'आइटम स्वामित्व में नहीं है',
      own_item: 'स्वयं की वस्तु',
      there_are_no_records: 'प्रदर्शित करने के लिए कोई रिकॉर्ड नहीं हैं',
      record_already_exists: 'रिकॉर्ड पहले से मौजूद है',
      record_not_exists: 'रिकार्ड मौजूद नहीं है',
      already_exists: 'पहले से ही मौजूद है',
      not_exists: 'अस्तित्व में नहीं है',
      not_updated: 'अद्यतन नहीं हुआ',
      forbidden: 'निषिद्ध',
    },
    bot: {
      not_found: 'बॉट नहीं मिला',
      not_available: 'बॉट उपलब्ध नहीं है',
    },
    wallet: {
      cannot_transfer_money: 'पैसे ट्रांसफर नहीं कर सकते',
      amount_negative: 'राशि ऋणात्मक',
      amount_positive: 'राशि सकारात्मक',
      card_scoring_too_low: 'कार्ड स्कोरिंग बहुत कम',
      not_enough_balance: 'पर्याप्त पैसा नहीं हैं',
      kyc_window_limit: 'KYC विंडो सीमा',
      service_window_limit: 'सेवा विंडो सीमा',
      amount_limit: 'राशि सीमा',
      wrong_wallet_address: 'गलत वॉलेट पता',
      card_not_found: 'कार्ड नहीं मिला',
      cannot_process_transaction: 'हम आपके लेनदेन को संसाधित नहीं कर सकते',
      only_past_months_accepted: 'केवल पिछले महीनों को स्वीकार किया गया',
      only_visa_allowed: 'केवल VISA कार्ड की अनुमति है',
      you_cannot_complete_this_action: 'आप यह कार्रवाई पूरी नहीं कर सकते क्योंकि आपके खाते में पर्याप्त धनराशि नहीं है।',
      you_need_to_deposit_at_least_x: 'इस कार्रवाई को पूरा करने के लिए आपको कम से कम {x} जमा करना होगा।',
    },
    gift_code: {
      not_found: 'कोड नहीं मिला',
      already_used: 'कोड पहले ही उपयोग किया जा चुका है',
      own_code: 'यह आपका अपना कोड है',
    },
    partner: {
      subaccount_not_enabled: 'Subaccount not enabled',
      link_account_first: 'पहले अकाउंट लिंक करें',
      account_already_linked: 'अकाउंट पहले से ही लिंक है',
      wrong_phrase: 'गलत मुहावरा',
      cannot_link_yourself: 'अपने आप को लिंक नहीं कर सकते',
      account_already_exists: 'अकाउंट पहले से मौजूद है',
    },
    payment: {
      card_scoring: 'कार्ड स्कोरिंग बहुत कम है',
      payment_issue: 'भुगतान मुद्दा',
    },
    auth: {
      failed_to_authenticate: 'प्रमाणित करने में विफल',
      not_valid_identity: 'वैध पहचान नहीं',
      authentication_failed: 'प्रमाणीकरण विफल होना',
    },
    social: {
      cannot_create_chat: 'चैट नहीं बनाई जा सकती',
    },
    support: {
      wrong_status: 'ग़लत स्थिति',
      ticket_limit: 'टिकट की सीमा',
    },
    ipn: {
      verification_issue: 'सत्यापन मुद्दा',
    },
    affiliate: {
      same_code: 'वही कोड',
      code_taken: 'यह कोड पहले ही लिया जा चुका है',
      not_activated: 'सक्रिय नहीं',
      not_enough_balance: 'पर्याप्त पैसा नहीं हैं',
    },
    bam: {
      bam_steam_015: 'हमारे बॉट्स ने स्टीम सत्र खो दिया है। कुछ ही मिनटों में पुनः प्रयास करें।',
    },
  },
  validator: {
    required: 'यह फ़ील्ड आवश्यक है.',
    string: 'यह फ़ील्ड एक स्ट्रिंग होनी चाहिए.',
    stringEmpty: 'यह फ़ील्ड खाली नहीं होनी चाहिए.',
    stringMin: 'इस फ़ील्ड की लंबाई कम से कम {expected} वर्ण लंबी होनी चाहिए.',
    stringMax: 'इस फ़ील्ड की लंबाई अधिकतम {expected} वर्ण लंबी होनी चाहिए।',
    stringLength: 'इस फ़ील्ड की लंबाई {expected} वर्ण लंबी होनी चाहिए.',
    stringPattern: 'यह फ़ील्ड आवश्यक पैटर्न से मेल खाने में विफल रहता है.',
    stringPatternLatin: 'कृपया केवल लैटिन अक्षरों का प्रयोग करें।',
    stringContains: 'इस फ़ील्ड में \'{expected}\' टेक्स्ट अवश्य होना चाहिए.',
    stringEnum: 'यह फ़ील्ड किसी भी स्वीकृत मान से मेल नहीं खाती.',
    stringNumeric: 'यह फ़ील्ड एक संख्यात्मक स्ट्रिंग होनी चाहिए.',
    stringAlpha: 'यह फ़ील्ड एक वर्णानुक्रमिक स्ट्रिंग होनी चाहिए.',
    stringAlphanum: 'यह फ़ील्ड अल्फ़ान्यूमेरिक स्ट्रिंग होनी चाहिए.',
    stringAlphadash: 'यह फ़ील्ड एक अल्फाडैश स्ट्रिंग होनी चाहिए.',
    stringHex: 'यह फ़ील्ड एक हेक्स स्ट्रिंग होनी चाहिए.',
    stringSingleLine: 'यह फ़ील्ड एक एकल पंक्ति स्ट्रिंग होनी चाहिए.',
    stringBase64: 'यह फ़ील्ड बेस64 स्ट्रिंग होनी चाहिए.',
    number: 'यह फ़ील्ड एक संख्या होनी चाहिए.',
    numberMin: 'यह फ़ील्ड {expected} से बड़ा या उसके बराबर होना चाहिए।',
    numberMax: 'यह फ़ील्ड {expected} से कम या उसके बराबर होनी चाहिए.',
    numberEqual: 'यह फ़ील्ड {expected} के बराबर होनी चाहिए.',
    numberNotEqual: 'यह फ़ील्ड {expected} के बराबर नहीं हो सकती.',
    numberInteger: 'यह फ़ील्ड पूर्णांक होनी चाहिए.',
    numberPositive: 'यह फ़ील्ड एक धनात्मक संख्या होनी चाहिए.',
    numberNegative: 'यह फ़ील्ड एक ऋणात्मक संख्या होनी चाहिए.',
    array: 'यह फ़ील्ड एक सरणी होनी चाहिए.',
    arrayEmpty: 'यह फ़ील्ड खाली सरणी नहीं होनी चाहिए.',
    arrayMin: 'इस फ़ील्ड में कम से कम {expected} आइटम होने चाहिए.',
    arrayMax: 'इस फ़ील्ड में {expected} आइटम से कम या उसके बराबर होना चाहिए।',
    arrayLength: 'इस फ़ील्ड में {expected} आइटम होने चाहिए.',
    arrayContains: 'इस फ़ील्ड में \'{expected}\' आइटम अवश्य होना चाहिए.',
    arrayUnique: '\'{actual}\' मान \'{expected}\' मानों को अद्वितीय नहीं बनाता है।',
    arrayEnum: '\'{actual}\' मान किसी भी \'{expected}\' मान से मेल नहीं खाता।',
    tuple: 'यह फ़ील्ड एक सरणी होनी चाहिए.',
    tupleEmpty: 'यह फ़ील्ड खाली सरणी नहीं होनी चाहिए.',
    tupleLength: 'इस फ़ील्ड में {expected} आइटम होने चाहिए.',
    boolean: 'यह फ़ील्ड बूलियन होनी चाहिए.',
    currency: 'यह फ़ील्ड एक वैध मुद्रा प्रारूप होना चाहिए',
    date: 'यह फ़ील्ड एक दिनांक होनी चाहिए.',
    dateMin: 'यह फ़ील्ड {expected} से बड़ा या उसके बराबर होना चाहिए।',
    dateMax: 'यह फ़ील्ड {expected} से कम या उसके बराबर होनी चाहिए.',
    enumValue: 'यह फ़ील्ड मान \'{expected}\' किसी भी स्वीकृत मान से मेल नहीं खाता है।',
    equalValue: 'यह फ़ील्ड मान \'{expected}\' के बराबर होना चाहिए.',
    equalField: 'यह फ़ील्ड मान \'{expected}\' फ़ील्ड मान के बराबर होना चाहिए.',
    forbidden: 'यह फ़ील्ड निषिद्ध है.',
    function: 'यह फ़ील्ड एक फ़ंक्शन होना चाहिए.',
    email: 'यह फ़ील्ड एक वैध ईमेल होना चाहिए.',
    emailEmpty: 'यह फ़ील्ड खाली नहीं होनी चाहिए.',
    emailMin: 'इस फ़ील्ड की लंबाई कम से कम {expected} वर्ण लंबी होनी चाहिए.',
    emailMax: 'इस फ़ील्ड की लंबाई अधिकतम {expected} वर्ण लंबी होनी चाहिए।',
    luhn: 'यह फ़ील्ड एक वैध चेकसम होना चाहिए।',
    mac: 'यह फ़ील्ड एक वैध मैक पता होना चाहिए।',
    object: 'यह फ़ील्ड एक ऑब्जेक्ट होना चाहिए.',
    objectStrict: 'इस ऑब्जेक्ट में निषिद्ध कुंजियाँ हैं: \'{actual}\'।',
    objectMinProps: 'इस ऑब्जेक्ट में कम से कम {expected} गुण होने चाहिए।',
    objectMaxProps: 'इस ऑब्जेक्ट में अधिकतम {expected} गुण होने चाहिए।',
    url: 'यह फ़ील्ड एक मान्य URL होना चाहिए.',
    urlEmpty: 'यह फ़ील्ड खाली नहीं होनी चाहिए.',
    uuid: 'यह फ़ील्ड मान्य कोड प्रारूप नहीं है.',
    uuidVersion: 'यह फ़ील्ड एक वैध UUID संस्करण प्रदान किया जाना चाहिए।',
    classInstanceOf: 'यह फ़ील्ड \'{expected}\' वर्ग का एक उदाहरण होना चाहिए।',
    objectID: 'यह फ़ील्ड एक वैध ऑब्जेक्टआईडी होनी चाहिए',
    record: 'यह फ़ील्ड एक ऑब्जेक्ट होना चाहिए.',
  },
  body: {
    language: 'भाषा',
    currency: 'मुद्रा',
    currency_warning: 'सभी ऑपरेशन अमेरिकी डॉलर में किए जाते हैं, यूएसडी के अलावा अन्य मुद्राओं को यूएसडी से परिवर्तित किया जाता है और केवल पृष्ठ को देखने का तरीका बदलता है। मुद्रा विनिमय दर में परिवर्तन से आपका शेष बढ़ या घट सकता है।',
    choose_game: 'खेल चुनें',
    slider: {
      title_1: 'अपनी शैली को उन्नत करें,',
      title_2: 'खेल पर हावी हो जाओ',
      content_1: 'खालों के सर्वोत्तम संग्रह की खोज करें',
      content_2: 'अपने गेमप्ले अनुभव को बेहतर बनाने के लिए।',
      tile_1: 'अपने गेमिंग अनुभव को अधिकतम करें',
      tile_2: 'अपने पैसे का सर्वोत्तम मूल्य प्राप्त करें',
      tile_3: 'सुरक्षित और निर्बाध व्यापार का आनंद लें',
    },
    footer_description: 'BitSkins में, हम गेमर्स को CS2, Dota 2, Rust और TF2 जैसे लोकप्रिय गेम से आइटम खरीदने और बेचने के लिए एक सुरक्षित मंच प्रदान करने के लिए समर्पित हैं। 2015 में अपने लॉन्च के बाद से, हमने लाखों संतुष्ट ग्राहकों को सफलतापूर्वक सेवा प्रदान की है, और सुरक्षा के प्रति हमारी प्रतिबद्धता पहले से कहीं अधिक मजबूत बनी हुई है।',
    footer_disclaimer: '© 2015 - {year} BitSkins. भाप द्वारा संचालित. वाल्व कार्पोरेशन से संबद्ध नहीं',
    footer_email_support: 'यदि आपको समर्थन की आवश्यकता है',
    footer_email_security: 'यदि आप बग की रिपोर्ट करना चाहते हैं',
    footer_email_partnership: 'यदि आप सहयोग करना चाहते हैं',
    market: 'बाज़ार',
    cart: 'शॉपिंग कार्ट',
    cart_empty: 'आपकी गाड़ी खाली है',
    clear_cart: 'कार्ट को खाली करें',
    checkout: 'चेक आउट',
    in_the_cart: 'गाड़ी में',
    total: 'कुल',
    go_to_market: 'बाज़ार जाएँ',
    trustpilot_alt: '{stars} सितारों और {reviews} समीक्षाओं के साथ ट्रस्टपायलट',
    reload_website: 'वेबसाइट पुनः लोड करें!',
    app_error: 'ऐप त्रुटि: {error}',
    latest_articles: 'नवीनतम लेख',
    steam_login: 'स्टीम लॉगिन',
  },
  maintenance: {
    we_will_be_back_soon: 'हम जल्द ही वापस होंगे',
    we_are_down_for_maintenance: 'हम रखरखाव के लिए नीचे हैं लेकिन हम शीघ्र ही ऑनलाइन वापस आ जाएंगे।',
    sorry_for_the_inconvenience: 'असुविधा के लिए खेद है और जल्द ही मिलते हैं!',
  },
  account: {
    email: {
      required: 'ईमेल पते की ज़रुरत है',
      required_for_this_payment_method: 'आप इस भुगतान विधि का उपयोग नहीं कर सकते क्योंकि आपने अपना ईमेल पता सेटअप नहीं किया है।',
      you_can_start_now: 'अब आप सेटअप प्रक्रिया शुरू कर सकते हैं.',
      setup: 'सेटअप ईमेल',
    },
    add_funds: 'धन जोड़ें',
    my_store: 'मेरी दुकान',
    selling: 'बेचना',
    transactions: 'लेनदेन',
    settings: 'सेटिंग',
    steam_settings: {
      open_settings: 'खुली सेटिंग',
      open_steam_settings: 'स्टीम प्रोफ़ाइल खोलें',
      what_is_steam_guard: 'स्टीम गार्ड क्या है?',
      inventory_status: 'माल सूची स्थिति',
      profile_status: 'प्रोफ़ाइल स्थिति',
      change_trade_link: 'ट्रेड लिंक बदलें',
    },
    logout: 'लॉग आउट',
    inventory: 'भंडार',
    banned: {
      you_are_banned: 'आप पर <span class="text-cr">प्रतिबंध </span>लगा है',
      your_account_has_been_banned: 'हमारा उल्लंघन करने के कारण आपके अकाउंट पर प्रतिबन्ध लगा दिया गया है',
      your_account_has_been_blocked: 'हमारा उल्लंघन करने के कारण आपका अकाउंट ब्लॉक कर दिया गया है',
      if_you_believe: 'यदि आपको लगता है कि यह एक गलती थी तो आप <span class="text-cp">support{\'@\'}bitskins.com</span> पर हमसे संपर्क कर सकते हैं',
      terms_of_use: 'उपयोग की शर्तें',
    },
    account_blocked: 'अकाउंट <span class="text-cr">ब्लॉक कर दिया</span>',
    api_access: 'API एक्सेस',
  },
  balance: {
    wallet: 'बटुआ',
    withdraw: 'रुपया निकालना',
    withdraw_to: 'को वापस ले लें',
    withdraw_again: 'फिर से वापस ले लो',
    withdrawable: 'निकाला',
    total: 'कुल',
    balance: 'संतुलन',
    deposits_and_sales: 'जमा और बिक्री',
    proceeds_from_sales: 'बिक्री से आय',
    deposit: 'जमा',
    locked: 'बंद',
    funds_locked: 'लेन-देन में फंसी निधि',
    pending_withdrawals: 'लंबित निकासी',
    thank_you_for_your_payment: 'अपने भुगतान के लिए धन्यवाद',
    your_money_will_arrive_soon: 'आपका पैसा जल्द ही आ जाएगा',
    your_payment_is_still_processing: 'आपका भुगतान अभी भी संसाधित हो रहा है, लेकिन धनराशि शीघ्र ही आपके खाते में आ जानी चाहिए।',
    in_case_you_do_not_receive: 'यदि आपको 15 मिनट के भीतर अपनी धनराशि प्राप्त नहीं होती है, तो कृपया हमारे समर्थन से संपर्क करें।',
    payment_pending: 'भुगतान <span class="text-cbs">लंबित</span>',
    payment_failed: 'भुगतान <span class="text-cr">विफल रही</span>',
    payment_canceled: 'भुगतान <span class="text-cg">रद्द कर दिया गया</span>',
    payment_has_been_cancelled: 'अनुरोध के अनुसार भुगतान रद्द कर दिया गया है',
    unfortunately_we_were_unable: 'दुर्भाग्य से हम आपका भुगतान संसाधित करने में असमर्थ रहे।',
    please_try_again: 'कृपया पुन: प्रयास करें',
    if_the_problem_persists: 'यदि समस्या बनी रहती है, तो कृपया हमारे समर्थन से संपर्क करें। आप किसी भिन्न भुगतान विधि का उपयोग करने का भी प्रयास कर सकते हैं।',
    back_to_wallet: 'बटुए पर वापस जाएँ',
    total_description: 'वह धनराशि जो आपकी जमा राशि और बिक्री से आती है।',
    withdrawable_description: 'बिक्री की आय. इन फंडों को निकाला जा सकता है या सामान खरीदने पर खर्च किया जा सकता है।',
    locked_description: 'अस्थायी रूप से लॉक की गई धनराशि जिसे खर्च या निकाला नहीं जा सकता। फंड लॉक होने का कारण मौजूदा खरीद ऑर्डर, वस्तुओं की खरीदारी आदि है...',
    deposit_with_cryptocurrencies: '<span class="text-cp">क्रिप्टोकरेंसी </span>के साथ जमा करें:',
    deposit_with_standard_payment_methods: '<span class="text-cp">मानक भुगतान विधियों</span> से जमा करें:',
    withdraw_with_cryptocurrencies: '<span class="text-cp">क्रिप्टोकरेंसी</span> से निकासी:',
    withdraw_with_standard_payment_methods: '<span class="text-cp">मानक भुगतान विधियों</span> से निकासी:',
    your_amount: 'आपकी राशि',
    your_limit: 'आपकी सीमा',
    your_limits: 'आपकी सीमाएं',
    increase_your_limits: 'अपनी सीमाएं बढ़ाएँ',
    payment_not_available_in_the_following_countries: 'यह भुगतान विधि निम्नलिखित देशों में उपलब्ध नहीं है:',
    the_price_is_updated_every_60_seconds: 'कीमत हर 60 सेकंड में अपडेट की जाती है और यह कई एक्सचेंजों से एकत्र की गई औसत कीमत है।',
    rate_includes_x_fee: 'दर में {x}% शुल्क शामिल है.',
  },
  not_found: {
    title: 'पृष्ठ नहीं मिला',
    message: 'ऐसा लगता है जैसे आप खो गए हैं. आप अपने <br>सपनों की खाल बाज़ार पृष्ठ पर पा सकते हैं।',
  },
  login: {
    welcome_to_bitskins: 'बिटस्किन्स में आपका <span class="text-cp">स्वागत है</span>',
    sign_in: 'साइन इन करे',
    sign_up: 'साइन अप करें',
    rules_text: 'मैं पुष्टि करता हूं कि मेरी उम्र 18 वर्ष या उससे अधिक है और मैं इससे सहमत हूं',
    sign_in_with_steam: 'स्टीम के साथ साइन इन करें',
    sign_up_with_steam: 'स्टीम के साथ साइन अप करें',
    email: 'ईमेल',
    password: 'पासवर्ड',
    already_have_an_account: 'क्या आपके पास पहले से एक खाता मौजूद है? क्लिक',
    to_login: 'लॉग इन करने के लिए',
    to_login_via_email: 'ईमेल के माध्यम से लॉगिन करने के लिए',
    login_via_email: 'ईमेल के माध्यम से लॉगिन करें',
    log_in_using_your_email: 'अपने ईमेल पते और पासवर्ड का उपयोग करके लॉग इन करें।',
    forgot_password: 'पासवर्ड भूल गए?',
    login_via_steam: 'स्टीम के माध्यम से लॉगिन करें',
    register_first: 'सबसे पहले आपको रजिस्ट्रेशन करना होगा',
    passwords_not_migrated: 'दुर्भाग्य से, हालिया अपडेट के दौरान हम आपका पासवर्ड माइग्रेट नहीं कर सके, इसलिए आपको इसे रीसेट करना होगा।',
  },
  common: {
    monthly: 'महीने के',
    x_to_y: '{x} से {y}',
    minimum_x: 'न्यूनतम {x}',
    maximum_x: 'अधिकतम {x}',
    click: 'क्लिक',
    claim: 'दावा',
    or: 'या',
    and: 'और',
    confirm: 'पुष्टि करना',
    continue: 'जारी रखना',
    cancel: 'रद्द करना',
    enable: 'सक्षम',
    enabled: 'सक्रिय',
    disable: 'अक्षम करना',
    disabled: 'अक्षम',
    download: 'डाउनलोड करना',
    twofa: 'दो तरीकों से प्रमाणीकरण',
    terms_of_use: 'उपयोग की शर्तें',
    privacy_policy: 'गोपनीयता नीति',
    cookie_policy: 'कूकी नीति',
    about_us: 'हमारे बारे में',
    changelog: 'बदलाव का',
    faq: 'सामान्य प्रश्न',
    support: 'सहायता',
    affiliate: 'संबद्ध',
    blog: 'ब्लॉग',
    careers: 'करियर',
    api: 'API',
    service_status: 'सेवा की स्थिति',
    loading: 'लोड हो रहा है...',
    buy_skins: 'स्किन्स खरीदें',
    sell_skins: 'स्किन्स बेचो',
    popular: 'लोकप्रिय',
    skin_categories: 'त्वचा श्रेणियाँ',
    payments: 'भुगतान',
    about_bitskins: 'बिटस्किन्स के बारे में',
    social_media: 'सामाजिक मीडिया',
    follow_us: 'हमारा अनुसरण करें और हमारे समुदाय में शामिल हों!',
    enter_your_email: 'अपना ईमेल पता दर्ज करें',
    phone_number: 'फ़ोन नंबर',
    verify: 'सत्यापित करें',
    add: 'जोड़ना',
    update: 'अद्यतन',
    check_spam_folder: 'यदि आपको अपने इनबॉक्स में ईमेल नहीं मिल रहा है तो कृपया अपना स्पैम फ़ोल्डर जांचें।',
    here: 'यहाँ',
    edit: 'संपादन करना',
    save: 'बचाना',
    copy: 'कॉपी',
    back: 'पीछे',
    back_to_login: 'लॉगिन पर वापस जाएं',
    clear: 'स्पष्ट',
    quantity: 'मात्रा',
    name: 'नाम',
    bot_name: 'बॉट का नाम',
    steam: 'स्टीम',
    steam_id: 'स्टीम पहचान',
    steam_group: 'स्टीम समूह',
    browser: 'ब्राउज़र',
    on: 'पर',
    off: 'बंद',
    hidden: 'छिपा हुआ',
    empty: 'खाली',
    expires_in: 'में समाप्त होना',
    member_since: 'से सदस्य',
    close: 'बंद करना',
    paint_seed_value: 'पेंट बीज: {value}',
    error: 'गलती',
    retry: 'पुन: प्रयास करें',
    no_options_available: 'कोई विकल्प उपलब्ध नहीं है',
    search: 'खोज',
    any: 'कोई',
    min: 'मिन',
    max: 'अधिकतम',
    no_limit: 'कोई सीमा नहीं',
    scroll_left: 'बाएँ स्क्रॉल करें',
    scroll_right: 'दाईं ओर स्क्रॉल करें',
    load: 'भार',
    delete: 'मिटाना',
    remove: 'निकालना',
    all: 'सभी',
    game: 'खेल',
    reset: 'रीसेट',
    in: 'में',
    optional: '(वैकल्पिक)',
    default: 'डिफ़ॉल्ट',
    filter: 'फ़िल्टर',
    up_to: 'तक',
    similar: 'समान',
    important: 'महत्वपूर्ण',
    step: 'कदम',
    share_link: 'लिंक शेयर करें',
    zoom: 'ज़ूम',
    found: 'मिला',
    try_again: 'पुनः प्रयास करें',
    of: 'का',
    timer: 'घड़ी',
    add_new: 'नया जोड़ो',
    and_more: 'और अधिक',
    check_status: 'स्थिति जाँचिए',
    resend_link: 'फिर से लिंक भेजें',
    back_to_home: 'घर की ओर वापस जाएं',
    data_visible_only_to_logged_in_users: 'यह डेटा केवल लॉग इन उपयोगकर्ताओं को ही दिखाई देता है',
    login: 'लॉग इन करें',
    level: 'स्तर',
    twofa_code: '2FA कोड',
    id: 'पहचान',
    position: 'पद',
    amount: 'मात्रा',
    progressive_sum: 'उन्नतिकारक योग',
    date: 'तारीख',
    active: 'सक्रिय',
    yes: 'हाँ',
    no: 'नहीं',
  },
  notifications: {
    change: 'परिवर्तन',
    setup: 'स्थापित करना',
    disconnect: 'डिस्कनेक्ट',
    connect: 'कनेक्ट',
    notifications: 'सूचनाएँ',
    notifications_center: 'सूचना केंद्र',
    clear_all: 'सभी सूचनाएं साफ़ करें',
    notifications_channels: 'सूचना चैनल',
    connected: 'कनेक्टेड',
    all_notifications: 'सभी अधिसूचनाएं',
    sound: 'आवाज़',
    volume_mute: 'आवाज़ म्यूट',
    volume_full: 'वॉल्यूम पूर्ण',
    all_sounds: 'सभी ध्वनियाँ:',
    off: 'बंद',
    on: 'पर',
    steam_issues_title: 'स्टीम समस्याएं',
    steam_issues_content: 'स्टीम उन समस्याओं का सामना कर रहा है जो ट्रेडों को प्रभावित कर सकती हैं, जिसके कारण उन्हें संसाधित या निर्मित नहीं किया जा सकता है।',
    name: {
      account_new_login: 'अकॉउंट नया लोगिन',
      inventory_sold: 'इन्वेंट्री बेची गई',
      inventory_buyorder: 'इन्वेंटरी खरीद आदेश',
      wallet_deposit_done: 'बटुआ जमा हो गया',
      support_new_reply: 'नए उत्तर का समर्थन करें',
      support_ticket_closed: 'समर्थन टिकट बंद',
      inventory_bargain_received: 'इन्वेंटरी सौदा प्राप्त हुआ',
    },
  },
  market: {
    non_scraped_only: 'केवल गैर-स्क्रेप्ड',
    set_price: 'कीमत निर्धारित करें',
    game_not_found: 'गेम नहीं मिली',
    game_not_available: 'गेम फिलहाल उपलब्ध नहीं है',
    any_stickers: 'कोई स्टिकर',
    item_removed_from_sale: 'आइटम को बिक्री से हटा दिया गया',
    price_updated: 'कीमत अपडेट की गई',
    item_withdrawn: 'यह मद वापस ले लिया गया है',
    go_to_withdrawn: 'वापस ली गई वस्तुओं पर जाएँ',
    item_issue: 'हमें इस आइटम से समस्या है',
    item_in_deposit_queue: 'यह आइटम जमा कतार में है',
    item_in_withdraw_queue: 'यह आइटम निकासी कतार में है',
    go_to_queued: 'कतारबद्ध आइटम पर जाएँ',
    item_in_bitskins_inventory: 'यह आइटम आपकी BitSkins इन्वेंटरी में है।',
    go_to_inventory: 'इन्वेंटरी में जाएं',
    go_to_issue: 'मुद्दों पर जाएं',
    maximum_price: 'अधिकतम कीमत',
    minimum_price: 'न्यूनतम कीमत',
    average_price: 'औसत मूल्य',
    amount_sold: 'बेची गई रकम',
    withdrawal_batch_info: 'कृपया ध्यान रखें कि हम हर कुछ मिनटों में बैचों में आइटम भेज रहे हैं।',
    queued: 'Queued',
    queued_description: 'यहां आप वे वस्तुएं पा सकते हैं जिनके लिए निकासी या जमा की कतार है।',
    withdrawn: 'वापस लिया गया',
    withdrawn_description: 'यहां आप वे आइटम पा सकते हैं जिन्हें वापस ले लिया गया है।',
    issues: 'समस्याएँ',
    issues_description: 'यहां आप वे आइटम पा सकते हैं जिनके साथ हमें समस्याएं आ रही हैं। हम फिलहाल इन मुद्दों को सुलझाने पर काम कर रहे हैं।',
    max_items_selected: 'आप {limit} से अधिक आइटम का चयन नहीं कर सकते',
    item_status: 'आइटम की स्थिति',
    search_for_stickers: 'स्टिकर खोजें',
    this_item: '(यह आइटम)',
    no_items_found: {
      no_items_found: 'कोई आइटम नहीं मिला',
      no_items_found_span: 'कोई आइटम नहीं<span> मिला</span>',
      we_could_not_find_any_offers: 'हमें कोई ऑफर नहीं मिला',
      for: 'के लिए',
      this_can_be_due_to_applied_filters: 'ऐसा लागू फ़िल्टर के कारण हो सकता है. आप नीचे दिए गए बटन पर क्लिक करके सभी फ़िल्टर साफ़ कर सकते हैं',
    },
    only_tradable_items: 'केवल व्यापार योग्य वस्तुएँ',
    not_accepting: 'स्वीकार नहीं कर रहा हूँ',
    sell: 'बेचना',
    skin: 'त्वचा',
    items: 'सामान',
    items_v2: 'सामान',
    buy_orders: 'ऑर्डर खरीदें',
    search_for: '{game} आइटम खोजें',
    search_for_items: 'वस्तुओं की खोज करें',
    reload: 'पुनः लोड करें',
    item_name: 'आइटम नाम',
    enter_item_name: 'आइटम का नाम दर्ज करें',
    price: 'कीमत',
    reset: 'रीसेट',
    all_items: 'सभी वस्तुएं',
    sort: 'क्रम से लगाना',
    add_sort: 'सॉर्ट जोड़ें',
    steam_price: 'स्टीम की कीमत',
    reference_price: 'संदर्भ कीमत',
    steam_inventory: 'स्टीम इन्वेंटरी',
    your_steam_inventory: 'आपकी स्टीम इन्वेंट्री',
    bitskins_inventory: 'बिटस्किन्स इन्वेंटरी',
    your_bs_inventory: 'आपकी बिटस्किन्स इन्वेंटरी {extra}',
    refresh: 'पुनः लोड करें',
    learn_how_to_sell: 'जानें कि कैसे बेचना है',
    select_1_by_1: '1 बटा 1 चुनें',
    select_all: 'सबका चयन करें',
    selected_items: 'चयनित उत्पाद',
    items_amount: '{count} आइटम',
    offers: 'ऑफर',
    favorites: 'पसंदीदा',
    last: 'अंतिम',
    viewed: 'देखा गया',
    same_price: {
      same_price_for: 'के लिए समान कीमत',
      all_items: 'सभी वस्तुएं',
    },
    save_all: 'सब को सुरक्षित करें',
    trade_hold: {
      name: 'व्यापार रोकें',
      between: '{min} और {max} दिनों के बीच लॉक किया गया',
      less: '{value} दिनों से कम समय के लिए लॉक किया गया',
      any: 'कोई भी व्यापार होल्ड',
      none: 'कोई व्यापार रोक नहीं',
      withdrawable_in_days_hours: '{days} दिनों, {hours} घंटों में निकासी योग्य',
      withdrawable_in_hours_minutes: '{hours} घंटे, {minutes} मिनट में निकासी योग्य',
      tradable: 'व्यापार योग्य',
    },
    filter: {
      status: 'स्थिति',
      date_from: 'तारीख से',
      date_to: 'की तारीख',
      amount_from: 'से राशि',
      amount_to: 'राशि के लिए',
      price_from: 'दाम से',
      price_to: 'कीमत को',
      service: 'सेवा',
      item: 'वस्तु',
      game: 'खेल',
      type: 'प्रकार',
      quality: 'गुणवत्ता',
      exterior: 'बाहरी',
      category: 'वर्ग',
      collection: 'संग्रह',
      color: 'रंग',
      family: 'स्किन परिवार',
      phase: 'चरण',
      rarity: 'दुर्लभ वस्तु',
      grade: 'श्रेणी',
      killstreak: 'किलस्ट्रीक',
      effect: 'प्रभाव',
      hero: 'नायक',
      nametag: 'नाम टैग',
      hightier: 'उच्च स्तरीय',
      stickers: 'स्टिकर',
      slot: 'स्लॉट {value}',
      paint_seed: 'पेंट बीज',
      paint_index: 'पेंट इंडेक्स',
      sticker_counter: 'स्टिकर राशि',
      float_value: 'तैरना',
      active: '{value} सक्रिय',
      by_slot_position: 'स्लॉट स्थिति के अनुसार',
      filter_name: 'नाम फ़िल्टर',
      you_can_have: 'तुम हो सकता है',
      filters_saved: 'फ़िल्टर सहेजे गए.',
      choose_stickers: 'स्टिकर चुनें',
      no_stickers_found: 'कोई स्टिकर नहीं मिला',
      basic_filters: 'बुनियादी फिल्टर',
      advanced_filters: 'उन्नत फ़िल्टर',
      clear_all_filters: 'सभी फ़िल्टर साफ़ करें',
      save_filters: 'फ़िल्टर सहेजें',
      my_filters: 'मेरे फ़िल्टर',
      filters_are_not_available_on_this_page: 'इस पृष्ठ पर फ़िल्टर उपलब्ध नहीं हैं',
    },
    loading_item: 'आइटम लोड हो रहा है',
    bestseller: 'सर्वश्रेष्ठ विक्रेता',
    this_is_your_item: 'यह आपकी वस्तु है',
    action: {
      screenshot: 'स्क्रीनशॉट',
      inspect: 'खेल में निरीक्षण करें',
      view_at_steam: 'स्टीम पर देखें',
      check_on_steam_market: 'स्टीम बाज़ार पर जाँच करें',
      share: 'शेयर करना',
      sell_instantly: 'तुरंत बेचें',
      buy: 'खरीदना',
      remove_from_sale: 'बिक्री से हटाएँ',
      check_on_market: 'बाजार पर जाँच करें',
      item_page: 'आइटम पेज',
      bulk_buy: 'थोक खरीद',
      add_to_favorites: 'पसंदीदा में जोड़े',
      remove_from_favorites: 'पसंदीदा से निकालें',
      buy_now: 'अभी खरीदें',
      bump: 'उभार',
      sticker: 'इस स्टिकर वाले आइटम',
    },
    bump_minimum: 'बम्पिंग केवल {amount} से अधिक मूल्य की वस्तुओं के लिए उपलब्ध है',
    your_price: 'आपका मूल्य',
    cart: {
      add_to_cart: 'कार्ट में जोड़ें',
      remove_from_cart: 'कार्ट से निकालें',
      add_stickers_to_cart: 'कार्ट में स्टिकर जोड़ें',
      remove: 'निकालना',
      in_cart: 'गाड़ी में',
    },
    details: 'विवरण',
    tags: 'टैग',
    do_you_want_rename: 'क्या आप अपने आइटम का नाम बदलना चाहते हैं?',
    currently_not_available: 'वर्तमान में उपलब्ध नहीं',
    nametag: 'नाम टैग',
    sales: 'बिक्री',
    private_offer: 'निजी प्रस्ताव',
    private_offers: 'निजी ऑफर',
    private_offers_description: 'आपके पास {counter} निजी ऑफ़र हैं। आप उन्हें पा सकते हैं',
    public_offer: 'सार्वजनिक प्रस्ताव',
    offer_visible_only_to_people_with_link: 'यह ऑफर केवल उन्हीं लोगों को दिखाई देगा जिनके पास इसका लिंक है',
    checkout: {
      if_any: 'यदि आपके कार्ट में कोई भी आइटम अब उपलब्ध नहीं है तो उन्हें आपके ऑर्डर में नहीं जोड़ा जाएगा।',
      remove_all_items: 'सभी आइटम हटाएँ',
      order_summary: 'आदेश सारांश',
      you_will_save: 'आप बचा लेंगे',
      i_have_read: 'मैंने सेवा की शर्तों और गोपनीयता नीति को पढ़ लिया है और उनसे सहमत हूं और मैं समझता हूं कि सभी खरीदारी अंतिम और गैर-वापसी योग्य है।',
      confirm_checkout: 'चेकआउट की पुष्टि करें',
      you_need_to_deposit_at_least_x: 'आपको अपने कार्ट में आइटम खरीदने के लिए कम से कम {amount} जमा करनी होगी।',
      you_cannot_complete: 'आप अपना ऑर्डर पूरा नहीं कर सकते क्योंकि आपके खाते में पर्याप्त धनराशि नहीं है। आपको अपने कार्ट में आइटम खरीदने के लिए कम से कम {amount} जमा करनी होगी',
      these_items_will_be_removed: 'चेकआउट के बाद ये आइटम सूची से हटा दिए जाएंगे।',
      this_item_will_not_be_included: 'यह आइटम आपके ऑर्डर में शामिल नहीं किया जाएगा',
      need_tos_accept: 'आपको सेवा की शर्तों और गोपनीयता नीति से सहमत होना होगा',
      no_items_selected: 'कोई आइटम चयनित नहीं',
    },
    deposit_status: {
      available: 'उपलब्ध',
      missing: 'गुम',
      not_accepting: 'स्वीकार नहीं कर रहा हूँ',
      wrong_price: 'गलत मूल्य',
      already_queue: 'पहले से ही कतार में हैं',
      locked: 'बंद',
    },
    withdraw_progress: {
      status: 'स्थिति वापस लें',
      selected: 'चयनित',
      waiting: 'इंतज़ार में',
      in_queue: 'क़तार में',
      trade_link: 'व्यापार लिंक',
      done: 'हो गया',
      error: 'गलती',
      failed: 'असफल',
      pending: 'लंबित',
    },
    trade_state: {
      Invalid: 'अमान्य',
      Active: 'सक्रिय',
      Accepted: 'स्वीकृत',
      Countered: 'मुकाबला',
      Expired: 'खत्म हो चुका',
      Canceled: 'रद्द',
      Declined: 'अस्वीकृत',
      InvalidItems: 'अमान्य आइटम',
      CreatedNeedsConfirmation: 'बनाया गया, पुष्टि की आवश्यकता है',
      CanceledBySecondFactor: 'दूसरे कारक द्वारा रद्द किया गया',
      InEscrow: 'निलंबलेख में',
    },
    trade_type: {
      deposit: 'जमा',
      withdraw: 'वापस लें',
      bidirectional: 'द्विदिश',
    },
    inventory: {
      history: 'इतिहास',
      active_trades: 'सक्रिय व्यापार',
      loading_your_inventory: 'अपनी इन्वेंटरी लोड हो रही है',
      lower_sale_fee: '{value}% कम सेल शुल्क',
      group_diff_price: 'ग्रुप में सभी आइटमों की कीमत नहीं होती है।',
      group_diff_delist: 'समूह में सभी आइटम हटाने के लिए चिह्नित नहीं हैं।',
      delist: 'डीलिस्ट',
      this_may_take_a_while: 'यह थोड़ी देर लग सकती है',
      relist_items: 'पुनः सूचीबद्ध आइटम',
      cancel_relisting: 'पुनः सूचीबद्ध करना रद्द करें',
      cancel_withdrawal: 'निकासी रद्द करें',
      withdraw_items: 'आइटम वापस लें',
      cancel_editing: 'संपादन रद्द करें',
      edit_items: 'आइटम संपादित करें',
      sell_items: 'वस्तुओं को बेचें',
      steam_offers: 'स्टीम ऑफ़र',
      clear_withdraw_items: 'साफ़ आइटम',
      loading_inventory: 'इन्वेंट्री लोड हो रही है',
      update_x_items: 'अद्यतित करें {amount} आइटम',
      delist_x_items: 'हटाएं {amount} आइटम',
    },
    message: {
      failed_to_create_trade_offer: 'व्यापार प्रस्ताव बनाने में विफल हो गया',
      offer: 'ऑफ़र {hash}',
      offer_failed: 'Offer failed (स्थिति {state} के साथ विफल हुआ)',
      offer_confirmed: 'आपके प्रस्ताव की पुष्टि हो गई है और आपने बिक्री के लिए अपने आइटम सफलतापूर्वक सूचीबद्ध कर लिए हैं',
      offer_sent: 'आपका व्यापार प्रस्ताव भेज दिया गया है',
      open_trade: 'खुला व्यापार प्रस्ताव',
      withdraw: 'ऑफ़र वापस लें {hash}',
      withdraw_confirmed: 'आपकी निकासी स्वीकार कर ली गई है',
      offer_preparing: 'आपका व्यापार तैयार किया जा रहा है. हम आपको जल्द ही प्रस्ताव भेजेंगे',
      offer_active: 'आपका व्यापार तैयार है. यहाँ स्वीकार करें',
      offer_needs_confirmation: 'मोबाइल ऐप में व्यापार की पुष्टि करें',
    },
    deposit_type: {
      public: 'सार्वजनिक',
      public_description: 'आपके आइटम सभी BitSkins उपयोगकर्ताओं को दिखाई देंगे। यह सबसे लोकप्रिय बिक्री विकल्प है.',
      private: 'निजी',
      private_description: 'आपके आइटम केवल उन्हीं लोगों को दिखाई देंगे जिनके पास उनका लिंक है। निजी बिक्री मानक बिक्री से 50% सस्ती है।',
      instant_sell: 'तुरंत बिक्री',
      instant_description: 'हमारे बॉट को आइटम भेजने के बाद, पैसा तुरंत आपके खाते में जमा कर दिया जाएगा।',
    },
    click_to_open: 'लिंक को नए टैब में खोलने के लिए क्लिक करें',
    no_active_trades: 'कोई सक्रिय व्यापार नहीं',
    go_to_all_trades: 'सभी ट्रेडों पर जाएँ',
    update_trade_link: 'ट्रेड लिंक अपडेट करें',
    withdraw: 'निकालना',
    lowest_price: 'सबसे कम कीमत:',
    no_filters_available: 'कोई फ़िल्टर उपलब्ध नहीं है',
    select_a_hero: 'एक नायक चुनें:',
    view_all_items: 'सभी आइटम देखें',
    stattrak: 'स्टेटट्रैक™',
    item_not_available: 'यह वस्तु अब उपलब्ध नहीं है',
    out_of_stock: 'स्टॉक ख़त्म',
    find_similar_item: 'समान वस्तु खोजें',
    find_similar_items: 'समान आइटम ढूंढें',
    sell_for: 'के लिए बेचना',
    recommended: 'अनुशंसित',
    price_discounted: 'रियायती मूल्य',
    price_average: 'औसत मूल्य (अनुशंसित)',
    price_expensive: 'उच्च कीमत',
    sticker: 'स्टिकर',
    more: 'अधिक',
    recent: 'हाल ही का',
    item_not_found: 'आइटम नहीं मिला',
    for: 'के लिए',
    you_will_pay: 'तुम्हें भुगतान किया जाएगा',
    fade: 'फीका: {value}%',
    see_all_items: 'सभी {amount} आइटम देखें',
    it_my_take_a_while: 'यह कुछ देर ले सकता है',
    no_transactions_found: 'कोई परिणाम नहीं मिले',
    item: 'वस्तु',
    edit: 'संपादन करना',
    add_items_to_edit: 'संपादित करने के लिए आइटम जोड़ें',
    add_items_to_delist: 'असूचीबद्ध करने के लिए आइटम जोड़ें',
    add_items_to_sale: 'बिक्री में आइटम जोड़ें',
    add_items_to_withdraw: 'वापस लेने के लिए आइटम जोड़ें',
    group_by_name: 'नाम से समूह',
    select_items_from_your_inventory: 'अपनी इन्वेंट्री से आइटम चुनें',
    earnings: 'आय',
    total_fee: 'कुल शुल्क',
    total_amount: 'कुल राशि',
    confirm_purchase: '<span class="text-cp">खरीदी</span> की पुष्टि करें',
    thank_you_for_shopping_with_us: 'हमारे साथ खरीददारी करने के लिए <span class="text-cp">धन्यवाद!</span>',
    you_have_purchased_x_items_for: 'आपने इसके लिए <span class="text-cp">{x}</span> आइटम खरीदे हैं',
    you_have_purchased_x_for: 'आपने <span class="text-cp">{x}</span> के लिए खरीदा है',
    total: 'कुल',
    you_saved: 'आपने बचा लिया',
    see_your_inventory: 'अपनी सूची देखें',
    you_bought: 'आप खरीदा',
    order_details: 'ऑर्डर का विवरण',
    items_not_available: 'दुर्भाग्य से आपके कार्ट से कुछ आइटम अनुपलब्ध हो गए, इसलिए आप उन्हें नहीं खरीद सके। नीचे आप इन वस्तुओं की एक सूची पा सकते हैं।',
    total_price: 'कुल कीमत',
    withdraw_all_items: 'सभी आइटम वापस ले लें',
    private_listing: 'निजी सूची {extra}',
    public_listing: 'सार्वजनिक सूची {extra}',
    instant_sale_price: 'तत्काल बिक्री मूल्य',
    not_accepted: 'स्वीकार नहीं किया गया',
    not_available: 'उपलब्ध नहीं है',
    no_sales_data: 'कोई बिक्री डेटा नहीं',
    create_buy_order: 'खरीद ऑर्डर बनाएं',
    active_buy_orders: 'आपके सक्रिय खरीद आदेश',
    buy_orders_history: 'खरीदें ऑर्डर इतिहास',
    market_buy_orders: 'बाजार खरीद आदेश',
    recent_sales: 'हाल की बिक्री',
    selling_price: 'विक्रय मूल्य',
    sales_chart: 'बिक्री चार्ट',
    sales_history_will_be_available_soon: 'BitSkins और स्टीम बिक्री इतिहास जल्द ही उपलब्ध होगा',
    souvenir: 'यादगार',
    under: '{amount} और उससे कम',
    above: '{amount} और ऊपर',
    amount_to_amount: '{amount1} से {amount2} तक',
    discount: 'छूट',
    value_off_or_more: '{value}% छूट या अधिक',
    removed_items: 'आइटम हटा दिए गए',
    restore_all_items: 'सभी आइटम पुनर्स्थापित करें',
    add_x_items_to_edit: 'एडिट करने के लिए {amount} आइटम जोड़ें',
    add_x_items_to_sale: '{amount} आइटम बिक्री में जोड़ें',
    add_x_items_to_withdraw: '{amount} आउट करने के लिए आइटम जोड़ें',
    sell_x_items: 'बेचें {amount} आइटम',
    withdraw_x_items: 'वापसी {amount} आइटम',
    first_you_need_to_select_an_item: 'सबसे पहले आपको एक आइटम का चयन करना होगा.',
    cheapest_price_on_bitskins: 'BitSkins पर सबसे सस्ती कीमत:',
    final_price: 'अंतिम कीमत:',
    check_quantity: 'मात्रा की जाँच करें',
    cancel_selected_orders: 'चयनित आदेश रद्द करें',
    cancel_all_orders: 'सभी ऑर्डर रद्द करें',
    community_rating: 'सामुदायिक रेटिंग:',
    rating: 'रेटिंग',
    votes: 'वोट',
    open_image: 'छवि खोलें',
    cheaper_than_steam_by_x: 'स्टीम से {x}% सस्ता',
    there_are_other_items_you_may_like: '<span>और भी चीज़ें हैं </span>जो आपको पसंद आ सकती हैं...',
    available_variants: 'उपलब्ध वेरिएंट',
    picture: {
      playside: 'खेल का मैदान',
      backside: 'पीठ',
      steam: 'स्टीम बाज़ार छवि',
    },
    buy_orders_not_available: 'खरीदें ऑर्डर फिलहाल उपलब्ध नहीं हैं',
    confirm_price_change: 'मूल्य परिवर्तन की पुष्टि करें',
    are_you_sure_to_change_price: 'क्या आप वाकई कीमत को<span class="text-cp fw-sb"> {price}</span> में बदलना चाहते हैं?',
  },
  bumps: {
    heading: 'क्या आप अपनी वस्तुओं की कीमत कम किये बिना<span class="text-cp"> उन्हें तेजी से बेचना चाहेंगे?</span>',
    subheading: 'हमारे पास आपके लिए कुछ है!',
    how_it_works: 'यह काम किस प्रकार<span class="text-cp"> करता है</span>?',
    description: 'BitSkins में हमारे पास एक बंपिंग विकल्प है जो आपको अपने आइटम को बाज़ार पृष्ठ और वेबसाइट पर कुछ अन्य स्थानों पर प्रदर्शित करने की अनुमति देता है। यह उन लोगों के लिए एक आदर्श समाधान है जो वस्तुओं की कीमत कम किए बिना उन्हें बेचने की प्रक्रिया को तेज़ करना चाहते हैं। जब आप कोई वस्तु उछालते हैं तो अधिक लोग उसे देखेंगे और उसके बिकने की संभावना बढ़ जाती है। आप अपने आइटम को केवल $0.75 या उससे भी कम से शुरू कर सकते हैं (कृपया हमारे बम्प पैकेज की जाँच करें)।',
    your_active_x_autobumps: 'आपका {x} ऑटो बम्प',
    bumps_packages: 'धक्कों वाले पैकेज',
    bumps: 'धक्कों',
    bumps_title: 'बम्प्स',
    available_bumps: 'उपलब्ध उभार',
    buy_selected_package: 'चयनित पैकेज खरीदें',
    when_you_bump: 'जब आप किसी आइटम को टक्कर देंगे तो वह निम्नलिखित स्थानों पर दिखाई देगा:',
    step_1_title: '<span class="text-cp">शीर्ष पट्टी</span> में बाज़ार पृष्ठ पर',
    step_2_title: '<span class="text-cp">मुख्य खंड</span> में बाजार पृष्ठ पर',
    step_2_text: '(यदि सॉर्टिंग विकल्प "विशेष रुप से प्रदर्शित" पर सेट किया गया हो तभी। यह डिफ़ॉल्ट विकल्प है।)',
    step_3_title: '<span class="text-cp">घर पृष्ठ </span>पर',
    step_4_title: 'आइटम पेज में <span class="text-cp">समान आइटम</span> स',
    step_5_title: '<span class="text-cp">सुझाए गए आइटम</span> सेक्शन में',
    after_bumping: 'किसी आइटम को बंप करने के बाद उसे प्रत्येक अनुभाग में पहले स्थान पर दिखाया जाएगा। हालाँकि, यदि आपके बाद कोई और अपना आइटम उछालता है तो आपका आइटम दूसरे स्थान पर चला जाएगा। आपका आइटम प्रत्येक अनुभाग में तब तक दिखाई देगा जब तक कि पर्याप्त उभार न हों जो उसे अनुभाग से बाहर धकेल दें।',
    how_to_bump: 'मेरे आइटम को कैसे उछाला जाए?',
    how_to_1: 'आइटम मेनू खोलें',
    how_to_2: 'बम्प विकल्प चुनें',
    how_to_3: 'बम्प प्रकार चुनें',
    how_to_4: 'हो गया!',
    table: {
      item: 'वस्तु',
      quantity: 'मात्रा',
      left: 'बाएं',
      period: 'अवधि',
      created_at: 'पर बनाया गया',
      updated_at: 'पर अद्यतन किया गया',
      next_bump_at: 'अगली टक्कर',
      action: 'कार्रवाई',
      status: 'स्थिति',
    },
    auto_enabled: 'ऑटो बम्प सक्षम',
    auto_disabled: 'ऑटो बम्प रद्द कर दिया गया',
    single_bumped: 'आइटम को टक्कर मार दी गई है!',
  },
  buy_order: {
    confirm_buy_orders_cancellation: 'खरीद आदेश रद्दीकरण की पुष्टि करें',
    are_you_sure_that_you_want_to_cancel: 'क्या आप वाकई अपने सभी खरीद ऑर्डर रद्द करना चाहते हैं?',
    create_buy_order: 'खरीद ऑर्डर बनाएं',
    predict_place_in_queue: 'कतार में स्थान की भविष्यवाणी करें',
    your_place_in_the_queue: 'कतार में आपका स्थान:',
    may_purchase_items_with_trade_hold: 'खरीदें ऑर्डर ट्रेड होल्ड के साथ आइटम खरीद सकते हैं।',
    create_a_buy_order_for_this_item: 'इस आइटम के लिए एक खरीद ऑर्डर बनाएं',
    no_buy_orders_found: 'कोई खरीद आदेश नहीं मिला',
    position_in_queue: 'कतार में स्थिति',
    this_is_your_buy_order: '(यह आपका खरीद आदेश है)',
    skin_name: 'चमड़े का नाम:',
    offers_on_market: 'बाजार पर ऑफर',
  },
  instant_sell: {
    confirmation: 'तुरंत बिक्री की पुष्टि',
    you_can_sell_x: 'आप AWP बेच सकते हैं | असीइमोव (फील्ड-टेस्टेड) ​​तुरंत और $10 प्राप्त करें।',
    the_funds_will_be_credited: 'धनराशि तुरंत आपके खाते में जमा कर दी जाएगी। यदि आप जारी रखना चाहते हैं तो "तुरंत बेचें" पर क्लिक करें',
  },
  sort: {
    select_option: 'विकल्प चुनें',
    apply: 'आवेदन करना',
    clear: 'स्पष्ट',
    default_order_placeholder: 'कोई विकल्प चुनें',
    select_order_placeholder: 'क्रमबद्ध करें का चयन करें',
    default_sort: 'डिफ़ॉल्ट सॉर्ट',
    custom_sort: 'कस्टम सॉर्ट',
    field: {
      price: 'कीमत',
      discount: 'छूट',
      id: 'तिथि जोड़ी',
      bumped_at: 'प्रदर्शित',
      suggested_price: 'सुझाव कीमत',
      asset_id: 'तिथि जोड़ी',
      float_value: 'तैरना',
      paint_index: 'पेंट इंडेक्स',
      paint_seed: 'पेंट बीज',
      extras_1: 'अतिरिक्त मूल्य',
      extras_1_fade: 'फीका',
      amount: 'मात्रा',
      name: 'नाम',
    },
    order: {
      price: {
        asc: 'सबसे पहले सबसे सस्ता',
        desc: 'महँगा पहले',
      },
      discount: {
        desc: 'सबसे पहले सबसे ऊंचा',
      },
      id: {
        asc: 'सबसे पुराना पहले',
        desc: 'नवीनतम पहले',
      },
      asset_id: {
        asc: 'सबसे पुराना पहले',
        desc: 'नवीनतम पहले',
      },
      bumped_at: {
        desc: 'गलती करना',
        asc: '',
      },
      default: {
        asc: 'सबसे कम सबसे पहले',
        desc: 'सबसे पहले सबसे ऊंचा',
      },
    },
  },
  pagination: {
    showing: 'दिखा',
    to: 'हिन्दी में',
    of: 'का',
    records: 'रिकॉर्ड',
  },
  popups: {
    click_confirmation_link: 'कृपया अपना ईमेल इनबॉक्स जांचें और प्रक्रिया पूरी करने के लिए पुष्टिकरण लिंक पर क्लिक करें।',
    steam_login_issue: {
      title: 'स्टीम लॉगिन समस्या',
      an_error_occured: 'स्टीम के माध्यम से लॉगिन करने का प्रयास करते समय एक त्रुटि उत्पन्न हुई। कृपया पुन: प्रयास करें।',
    },
    steam_inventory_private: {
      title: 'आपकी स्टीम इन्वेंटरी <span class="text-cp">निजी</span> है।',
      we_were: 'हम आपकी स्टीम इन्वेंट्री लोड करने में असमर्थ रहे। कृपया अपनी इन्वेंट्री स्थिति को सार्वजनिक में बदलें।',
      you_can: 'आप इसे स्टीम सेटिंग्स में कर सकते हैं। ध्यान रखें कि परिवर्तनों का पता लगाने में हमें कुछ मिनट लग सकते हैं।',
      steam_settings: 'स्टीम सेटिंग्स',
    },
    account_deletion_in_progress: {
      title: 'अकाउंट हटाया जा रहा है...',
      process_started: 'अपना अकाउंट हटाने की प्रक्रिया शुरू कर दी है.',
      account_will_be_deleted: 'आपका अकाउंट हटा दिया जाएगा',
      cancel_deletion: 'विलोपन रद्द करें',
      confirm_deletion: 'मिटाने की पुष्टि',
      check_your_email: 'अपने ईमेल की जाँच करें',
    },
    account_deletion_confirm: {
      title: 'अकाउंट हटाने की पुष्टि करें',
      subtitle: 'क्या आप इस अकॉउंट को हटाने के लिए सुनिश्चित हैं?',
      once_you_confirm: 'एक बार सत्यापन के बाद, आप स्वचालित रूप से लॉग आउट हो जाएंगे और आपके सभी खाते का डेटा दो सप्ताह के बाद स्थायी रूप से हटा दिया जाएगा। इन दो सप्ताहों के दौरान आप अपने खाते में लॉग इन करके डिलीट प्रक्रिया को रद्द कर सकेंगे।',
      once_your_account_is: 'एक बार जब आपका खाता हटा दिया जाता है तो आप वेबसाइट पर लॉग इन करके एक नया BitSkins खाता बना सकेंगे।',
      however_you_will_not: 'हालाँकि, आपके पास हटाए गए डेटा तक पहुंच नहीं होगी।',
      if_you_want_to_continue: 'यदि आप जारी रखना चाहते हैं तो पुष्टि पर क्लिक करें और हमारे द्वारा आपको भेजे गए ईमेल में पुष्टिकरण लिंक पर क्लिक करें।',
      login: 'खाता हटाए जाने की पुष्टि करने के लिए आपको लॉग इन करना होगा',
      canceled: 'खाता विलोपन रद्द कर दिया गया है',
      confirmed: 'खाता हटाने की पुष्टि की गई',
    },
    account_deletion_check_your_email: {
      title: 'अपने ईमेल की जाँच करें',
      to_complete: 'खाता हटाने की प्रक्रिया पूरी करने के लिए, हमारे द्वारा आपको भेजे गए ईमेल में पुष्टिकरण लिंक पर क्लिक करें।',
    },
    twofa_enable: {
      already_done: 'आपने पहले ही 2FA सक्षम कर लिया है.',
      setup_email_before: '2FA सक्षम करने के लिए आपको पहले ईमेल सेटअप करना होगा।',
      twofa_authentication_adds: 'दो-कारक प्रमाणीकरण (2FA) आपकी पहचान को सत्यापित करने के लिए दो तरीकों (कारकों) की आवश्यकता के द्वारा आपके खाते में सुरक्षा की एक अतिरिक्त परत जोड़ता है। आपके खाते को सुरक्षित रखने के लिए 2FA को सक्षम करने की दृढ़ता से अनुशंसा की जाती है, क्योंकि यह अतिरिक्त 2FA कोड तक पहुंच के बिना अवांछित लॉगिन को रोकता है।',
      setup_twofa: 'दो-कारक प्रमाणीकरण सेट करें',
      if_you_dont_have_an_authenticator_app: 'यदि आपके पास प्रमाणक ऐप नहीं है',
      we_recommend: 'हम एंड्रॉइड और आईओएस उपयोगकर्ताओं के लिए <a href="https://support.google.com/accounts/answer/1066447?hl=en" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator</a> या <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> की सिफारिश करते हैं। यदि आप अपने कंप्यूटर पर ऐप का उपयोग करना चाहते हैं, तो आप <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> डाउनलोड और स्थापित कर सकते हैं या अपने ब्राउज़र में <a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator एक्सटेंशन</a> का उपयोग कर सकते हैं।\\',
      scan_the_qr_code: 'QR कोड को स्कैन करें',
      open_your_authenticator_app: 'अपना प्रमाणक ऐप खोलें और क्यूआर कोड स्कैन करें या गुप्त कुंजी मैन्युअल रूप से दर्ज करें।',
      secret_key: 'गुप्त कुंजी',
      this_secret_key_will_be_valid_for_x_seconds: 'यह गुप्त कुंजी {x}@:{\'time.seconds\'} के लिए मान्य होगी।',
      save_this_secret: 'इस गुप्त कुंजी को किसी सुरक्षित स्थान पर सहेजें। जब आप प्रमाणक ऐप तक पहुंच खो देंगे तो यह आपको अपने 2FA कोड तक पहुंच पुनः प्राप्त करने की अनुमति देगा।',
      enter_the_6_digit_code: 'अपने प्रमाणक ऐप द्वारा उत्पन्न 6-अंकीय कोड दर्ज करें',
      enter_code_from_the_email: 'ईमेल से कोड दर्ज करें',
      enter_the_verification_code: 'हमारे द्वारा {email} पर भेजा गया सत्यापन कोड दर्ज करें।',
      desktop: 'डेस्कटॉप',
    },
    twofa_enabled: {
      now_your_account_is: 'अब आपका खाता दो-कारक प्रमाणीकरण द्वारा सुरक्षित है।',
      all_future_logins: 'अब भविष्य के सभी लॉगिन के लिए आपको अपने प्रमाणक ऐप द्वारा प्रदत्त कोड दर्ज करना होगा।',
    },
    twofa_enter_code: 'अपने प्रमाणक ऐप द्वारा जनरेट किया गया 2FA कोड दर्ज करें।',
    twofa_disable: {
      title: 'दो-कारक प्रमाणीकरण अक्षम करें',
      enter_the_6_digit_code: 'अपने प्रमाणीकरण ऐप द्वारा उत्पन्न 6-अंकीय कोड दर्ज करें।',
      cannot_access: 'आपके सत्यापन कोड तक नहीं पहुंच सकते? कृपया हमसे सम्पर्क करें यहां',
    },
    twofa_disabled: 'आपका खाता अब दो-कारक प्रमाणीकरण द्वारा सुरक्षित नहीं है।',
    order_unable_to_process: {
      title: 'हम आपका आदेश संसाधित करने में असमर्थ रहे',
      an_error_occurred: 'आपका ऑर्डर संसाधित करते समय एक त्रुटि उत्पन्न हुई. कृपया चेकआउट पृष्ठ पर वापस जाएं और दोबारा ऑर्डर देने का प्रयास करें।',
      back_to_checkout: 'वापस चेकआउट करने के लिए',
      back_to_item: 'आइटम पर वापस जाएं',
      information: 'यदि यह त्रुटि अक्सर होती है, तो आपको हमसे संपर्क करना चाहिए। त्रुटि कोड सहित <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">समर्थन पृष्ठ</a> के माध्यम से।',
    },
    phone_number_add: {
      title: 'अपना फ़ोन नंबर जोड़ें',
      to_continue: 'जारी रखने के लिए, पहले आपको अपने खाते में अपना फोन नंबर जोड़ना होगा।',
      add_number: 'संख्या जोड़ें',
    },
    phone_number_confirmed: {
      title: 'फ़ोन नंबर की पुष्टि की गई',
      your_phone_number: 'आपके फ़ोन नंबर की पुष्टि हो गई है.',
    },
    phone_number_verify: {
      title: 'अपना फोन का नंबर जांच लें',
      to_verify: 'अपना फ़ोन नंबर सत्यापित करने के लिए आपको हमारे द्वारा भेजा गया सत्यापन कोड दर्ज करना होगा',
      enter_sms_code: 'एसएमएस कोड दर्ज करें',
      you_cannot_update: 'आप इस चरण में अपना फ़ोन नंबर अपडेट नहीं कर सकते. आप इसे {minutes} मिनटों में कर पाएंगे.',
    },
    phone_number_verification_in_progress: {
      title: 'फ़ोन नंबर सत्यापन प्रगति पर है',
      if_you_wish: 'आप चाहें तो अपना फ़ोन नंबर अपडेट कर सकते हैं या सत्यापन कोड दोबारा भेज सकते हैं।',
      send_code: 'कोड भेजो',
    },
    email_address_add: {
      your_email_address: 'आपका ईमेल पता',
      by_providing_my_email: 'अपना ईमेल पता प्रदान करके मैं विपणन संचार प्राप्त करने के लिए सहमत हूं',
      verification_in_progress: 'ईमेल सत्यापन प्रगति पर है',
      to_verify: 'अपना ईमेल पता सत्यापित करने के लिए आपको हमारे द्वारा भेजे गए ईमेल में पुष्टिकरण लिंक पर क्लिक करना होगा',
      if_you_wish: 'यदि आप चाहें तो अपना ईमेल पता अपडेट कर सकते हैं या सक्रियण लिंक पुनः भेज सकते हैं।',
    },
    email_address_verify: {
      we_are_verifying: 'हम आपके ईमेल पते का सत्यापन कर रहे हैं और इसमें कुछ समय लग सकता है...',
      confirmed: 'आपके ईमेल पते की पुष्टि हो गई है.',
    },
    email_address_confirmed: {
      title: 'ईमेल पते की पुष्टि की गई',
      your_email_address: 'आपके ईमेल पते की पुष्टि हो गई है.',
    },
    enter_your_trade_url: {
      title: 'अपना ट्रेड URL दर्ज करें',
      to_continue: 'जारी रखने के लिए, सबसे पहले आपको अपना व्यापार URL सेट करने की आवश्यकता है। आप इसे यहां मिलेगा।',
      your_trade_url: 'आपका व्यापार यूआरएल',
    },
    password_reset_enter_email: {
      forgot: 'अपना पासवर्ड भूल गए हैं',
      password: 'पासवर्ड?',
      dont_worry: 'चिंता न करें, नीचे अपना ईमेल पता दर्ज करें।',
      we_will_send: 'हम आपको आपका पासवर्ड रीसेट करने के लिए एक लिंक भेजेंगे।',
      send_reset_link: 'रीसेट लिंक भेजें',
      if_this_email: 'यदि यह ईमेल पता BitSkins खाते से संबद्ध है,',
      you_will_receive: 'आपको अपना पासवर्ड रीसेट करने के लिंक के साथ एक ईमेल प्राप्त होगा।',
    },
    password_reset_new_password: {
      enter_your: 'अपना भरें',
      new_password: 'नया पासवर्ड',
      enter_password: 'पास वर्ड दर्ज करें',
      repeat_password: 'पासवर्ड दोहराएं',
      save_password: 'पासवर्ड को बचाओ',
    },
    link_expired: {
      title: 'लिंक की अवधि समाप्त हो',
      the_process_cannot: 'यह प्रक्रिया पूरी नहीं की जा सकती. लिंक पहले ही समाप्त हो चुका है.',
      go_to_settings: 'सेटिंग्स में जाओ',
    },
    wrong_link: {
      title: 'गलत लिंक',
      we_were_unable: 'हम आपके अनुरोध पर कार्रवाई करने में असमर्थ रहे. आपने गलत लिंक का अनुसरण किया है.',
    },
    trade_preparing: {
      title: 'हम आपका व्यापार प्रस्ताव तैयार कर रहे हैं',
      processing: 'इसमें कुछ सेकंड लग सकते हैं...',
    },
    trade_sent: {
      trade_offer_has_been_sent: 'आपका व्यापार प्रस्ताव है <span class="text-cp">भेजा गया है</span>',
    },
    trade_done: {
      title: 'व्यापार प्रस्ताव स्वीकार कर लिया गया है',
      listed: 'आपने अपने वस्तुओं को सफलतापूर्वक बिक्री के लिए सूचीबद्ध कर दिया है। आप इन्हें <a rel="nofollow noopener noreferrer" href="https://bitskins.com/selling" class="text-cp">बिक्री टैब</a> में प्रबंधित कर सकते हैं।',
      see_listed: 'अपने सूचीबद्ध आइटम देखें',
      withdrawn: 'आपने अपना सामान सफलतापूर्वक वापस ले लिया है.',
    },
    trade_declined: {
      your_trade_offer_has_been: 'आपका व्यापार प्रस्ताव रहा है',
      declined: 'अस्वीकृत',
      if_you: 'यदि आपने इसे स्वयं अस्वीकार नहीं किया है तो इसका मतलब है कि कोई आपके खाते का उपयोग कर रहा है और आपके आइटम चोरी होने का खतरा हो सकता है।',
      to_stay: 'अपनी वस्तुओं की सुरक्षा के लिए शीघ्रता से कार्य करना चाहिए और इन चरणों का पालन करना चाहिए:',
      step_revoke: 'अपनी स्टीम वेब एपीआई कुंजी निरस्त करें।',
      step_revoke_btn: 'API कुंजी निरस्त करें',
      step_password: 'अपना स्टीम पासवर्ड बदलें।',
      step_password_btn: 'पासवर्ड बदलें',
      step_deauth: 'स्टीम पर सभी उपकरणों को अनधिकृत करें।',
      step_deauth_btn: 'उपकरणों को अधिकृत करें',
      step_trade: 'एक नया स्टीम ट्रेड यूआरएल बनाएं।',
      step_trade_btn: 'नया ट्रेड यूआरएल बनाएं',
      step_new: 'BitSkins पर अपना नया ट्रेड लिंक सेट करें।',
      step_new_btn: 'नया व्यापार URL सेट करें',
      step_try: 'अपने आइटम दोबारा जमा करने का प्रयास करें और देखें कि क्या समस्या बनी रहती है।',
      step_try_if: 'यदि ऐसा होता रहता है, तो सभी व्यापार बंद कर दें और हमारे समर्थन से संपर्क करें।',
      contact_support: 'समर्थन से संपर्क करें',
      information: 'ध्यान रखें कि हमारे स्टाफ सदस्य और बॉट कभी भी स्टीम चैट, डिस्कॉर्ड या कहीं और के माध्यम से कोई जमा राशि नहीं मांगेंगे - एडमिन आदि होने का दावा करने वाला कोई भी व्यक्ति गलत है और संभवतः आपके साथ धोखाधड़ी करना चाहता है। सुरक्षित रहें!',
    },
    trade_failed: {
      offer_failed_title: 'व्यापार प्रस्ताव विफल रहा',
      offer_failed_text: 'दुर्भाग्य से आपका व्यापार प्रस्ताव विफल हो गया है। कृपया पुन: प्रयास करें।',
      offer_failed_to_create_title: 'व्यापार प्रस्ताव बनाने में विफल',
      offer_failed_to_create_text: 'दुर्भाग्य से हम आपका व्यापार प्रस्ताव बनाने में असमर्थ रहे। कृपया पुन: प्रयास करें।',
      contact_support: 'यदि यह त्रुटि अक्सर होती है, तो आपको हमसे संपर्क करना चाहिए। <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">सहायता पेज</a> के माध्यम से।',
      support_page: 'समर्थनकारी पृष्ठ',
      cannot_process: 'हम आपके व्यापार प्रस्ताव पर कार्रवाई नहीं कर सकते',
      unfortunately_we_were_unable: 'दुर्भाग्य से, हम आपके व्यापार प्रस्ताव को संसाधित करने में असमर्थ रहे। सबसे अधिक संभावना है कि आपके पास इन वस्तुओं के लिए पहले से ही एक सक्रिय व्यापार प्रस्ताव है।',
    },
    items_not_available: {
      title: 'आइटम अब बिक्री के लिए उपलब्ध नहीं हैं',
      unfortunately: 'दुर्भाग्य से आपके कार्ट के आइटम अब बिक्री के लिए उपलब्ध नहीं हैं।',
      dont_worry: 'चिंता न करें, आप बाज़ार पृष्ठ पर बहुत सारे आइटम पा सकते हैं।',
      unavailable_items: 'अनुपलब्ध वस्तुएँ',
      back_to_market: 'बाजार में वापस',
    },
    bump_purchase_confirmation: {
      title: 'खरीद की पुष्टि',
      do_you_want_to_purchase: 'क्या आप <span class="text-cp">{quantity} बंप्स</span> खरीदना चाहते हैं <span class="text-cp">{price}</span>?',
      bumps_package: 'धक्कों का पैकेज',
    },
    bump_start: {
      title: 'अपना सामान उछालो',
      bump_your_item: 'अपने आइटम को बम्प करें ताकि यह मार्केट पेज पर और वेबसाइट के कुछ अन्य स्थानों पर विशेषता प्राप्त करें।<br> इससे अधिक लोगों द्वारा ध्यान दिया जाएगा, इसलिए अपने आइटम को जल्दी बेचने में मदद मिल सकती है।<br> यदि आप यह जानना चाहते हैं कि बम्पिंग फीचर कैसे काम करता है, तो और अधिक जानने के लिए।',
      click_here: 'यहाँ क्लिक करें',
      single_bump: 'एकल टक्कर',
      autobumps: 'एकल टक्कर',
      one_bump: '1 टक्कर',
      this_option_single_bump: 'यह विकल्प आपके आइटम को केवल एक बार ही उच्चित करेगा और इसका खर्च <span class="text-cp">$0.75</span> होगा। यदि आपके खाते में पहले से ही उपलब्ध उच्चित होते हैं, तो आपके शेष राशि से कोई भी चार्ज नहीं किया जाएगा।',
      this_option_autobumps: 'इस विकल्प से आपके आइटम को चयनित समयावधि में हर बार ऊंचा किया जाएगा। यदि आपके खाते में पहले से ही उपलब्ध ऊंचाई हैं तो आपके शेष राशि से कोई चार्ज नहीं किया जाएगा। यदि आपकी ऊंचाई समाप्त हो जाती है तो प्रत्येक एकल ऊंचाई पर आपके शेष राशि से $0.75 कटेगा। आप अग्रिम में और ऊंचाई खरीद सकते हैं और उसी समय <span class="text-cp">कुछ पैसे बचा सकते हैं</span> - ऊंचाई पैकेज की जांच करने के लिए नीचे स्क्रॉल करें।',
      bump_every: 'हर एक को टक्कर मारो',
      bumps_amount: 'धक्कों की मात्रा',
      delayed_start: 'देरी से प्रारम्भ',
      delayed_start_description: 'इस विकल्प को चेक करने से आपका पहला बम्प चयनित समयावधि से विलंबित हो जाएगा।',
    },
    bump_stop: {
      title: 'ऑटो धक्कों को रोकें',
      do_you_want: 'क्या आप इस आइटम के लिए ऑटो बम्प रोकना चाहते हैं?',
    },
    bulk_buy: {
      bulk_buy: 'थोक खरीद',
      maximum_items_you_can_buy: 'इस कीमत पर आप अधिकतम आइटम खरीद सकते हैं:',
      may_purchase_items_with_trade_hold: 'थोक खरीद सुविधा ट्रेड होल्ड के साथ आइटम खरीद सकती है।',
    },
  },
  affiliate: {
    ad_info: 'यदि आपको बॉक्स नहीं दिखता है, तो कृपया एडब्लॉक को अक्षम करने का प्रयास करें।',
    affiliate_code: 'गुप्तचिन्ह सहबद्ध करना',
    affiliate_link: 'सहबद्ध लिंक',
    level: 'स्तर',
    levels: 'संबद्ध स्तर',
    our_levels: 'हमारे स्तर',
    your_code: 'आपका सहबद्ध कोड',
    your_affiliate_statistics: 'आपके संबद्ध आँकड़े',
    earn_money_by_simply_sharing: 'अपने दर्शकों के साथ BitSkins के प्रति अपना प्यार साझा करके पैसे कमाएँ!',
    percent_from_sale_fee: 'बिक्री शुल्क से {value}%',
    join_the_bitskins_affiliate: 'BitSkins सहबद्ध कार्यक्रम में शामिल हों और अपने अद्वितीय सहबद्ध लिंक के माध्यम से की गई प्रत्येक बिक्री पर कमीशन अर्जित करें। चाहे आपके पास बड़ी संख्या में अनुयायी हों या केवल कुछ करीबी दोस्त हों, जितना अधिक आप साझा करेंगे, उतना अधिक आप कमाएंगे।',
    tile_1_title: 'अपने दर्शकों के साथ BitSkins साझा करें',
    tile_1_description: 'कुछ ही सेकंड में अपना खुद का संबद्ध लिंक बनाएं और इसे अपने दोस्तों या अपने दर्शकों के साथ साझा करना शुरू करें।',
    tile_2_title: 'अपना मुनाफ़ा बढ़ता हुआ देखें',
    tile_3_title: 'अपनी कमाई का दावा करें',
    tile_3_description: 'संबद्ध कार्यक्रम से प्राप्त धनराशि को वस्तुओं की खरीद पर खर्च किया जा सकता है या बिटस्किन्स से निकाला जा सकता है। यह आप पर निर्भर करता है!',
    kyc_you_cannot_use: 'आप संबद्ध प्रणाली का उपयोग नहीं कर सकते क्योंकि आप केवाईसी प्रक्रिया से नहीं गुजरे हैं। अब आप सत्यापन प्रक्रिया शुरू कर सकते हैं.',
    your_percentage: 'आपका प्रतिशत',
    generated: 'जनरेट किया गया',
    individual_affiliate_program: 'व्यक्तिगत सहबद्ध कार्यक्रम',
    if_you_or_your_business: 'यदि आप या आपका व्यापार ईस्पोर्ट्स उद्योग में शामिल है या बड़े सामाजिक मीडिया पहुंच उत्पन्न करता है, तो कृपया हमसे संपर्क करें partnership{\'@\'}bitskins.com. हम आपको व्यक्तिगत सहयोग शर्तें प्रदान कर सकते हैं.',
    invited_referrals: 'आमंत्रित रेफरल',
    active_referrals: 'सक्रिय रेफरल',
    your_percentage_sales_fee: 'आपका प्रतिशत बिक्री शुल्क',
    your_total_earnings: 'आपकी कुल कमाई',
    available_earnings: 'उपलब्ध कमाई',
    you_can_claim_your_earnings_one_a_day: 'आप दिन में एक बार अपनी कमाई का दावा कर सकते हैं। एक बार जब आप उन पर दावा कर देते हैं तो वे 24 घंटों के भीतर आपके निकासी योग्य शेष राशि में दिखाई देंगे। भुगतान के लिए न्यूनतम राशि है',
    to_reach_the_next_level: 'अगले स्तर तक पहुंचने और उच्च कमीशन अर्जित करने के लिए, आपको अपने रेफरल के माध्यम से बिक्री में {x} उत्पन्न करना होगा।',
    any_user_that_registers_from_your_affiliate_link: 'Any user that registers from your affiliate link will be automatically assigned as your referee',
    my_earnings: 'मेरी कमाई',
    referred_users: 'संदर्भित उपयोगकर्ता',
    code_updated: 'एफिलिएट कोड सफलतापूर्वक अपडेट किया गया',
    not_enough_money: 'स्थानांतरित करने के लिए पर्याप्त धन नहीं है',
    account: 'खाता',
    referrals_sales: 'रेफरल बिक्री इतिहास',
  },
  profile: {
    hi: 'नमस्ते',
    nav: {
      account: 'खाता',
      wallet: 'बटुआ',
      transactions: 'लेनदेन',
      statistics: 'आंकड़े',
      affiliate: 'संबद्ध',
      company: 'कंपनी',
      trades: 'ट्रेडों',
      items_history: 'आइटम इतिहास',
    },
    top_star: {
      you_are: 'तुम हो',
      top_star: 'टॉप स्टार',
      good_to_see_you: 'हे "{username}", BitSkins पर आपको देखकर अच्छा लग रहा है!',
      appreciate_using: 'हम सराहना करते हैं कि आपने हमारे मंच का उपयोग करने का निर्णय लिया है,',
      extra_settings: 'इसलिए हमने आपके लिए कुछ अतिरिक्त सेटिंग्स तैयार की हैं।',
      show_nickname_selling: 'बेचते समय आइटम पृष्ठ पर मेरा उपनाम दिखाएँ',
      show_nickname_store: 'स्टोर पेज पर मेरा उपनाम हाइलाइट करें',
    },
    basic: {
      basic_information: 'मूल जानकारी',
      username: 'उपयोगकर्ता नाम',
      change_username: 'उपयोगकर्ता नाम परिवर्तन करें',
      registration_date: 'पंजीकरण की तारीख',
      email: 'ईमेल',
      change_email: 'बदले ई - मेल',
      password: 'पासवर्ड',
      change_password: 'पासवर्ड बदलें',
      phone: 'फ़ोन नंबर',
      change_phone: 'फ़ोन बदलें',
      hide_balance: 'अपना संतुलन छुपाएं',
      hide_balance_description: 'धनराशि की राशि हेडर से छिपा दी जाएगी, यह वॉलेट पर दबाने के बाद भी दिखाई देगी।',
    },
    security: {
      you_can_access_your_account: 'आप API कुंजी के माध्यम से अपने खाते तक पहुंच सकते हैं। हमारा API दस्तावेज़ स्थित है',
      api_status: 'API स्थिति',
      security: 'सुरक्षा',
      twofa: 'दो तरीकों से प्रमाणीकरण',
      temporarily_block_my_account: 'मेरे खाते को अस्थायी रूप से ब्लॉक करें',
      temporarily_block_title: 'मेरे खाते को अस्थायी रूप से ब्लॉक करें',
      temporarily_block_description: 'यदि आपको लगता है कि आपका खाता हैक हो गया है, तो आप इसे अस्थायी रूप से ब्लॉक कर सकते हैं। हम आपके खाते को हमारे सपोर्ट से संपर्क करने के बाद अनब्लॉक करेंगे।',
      temp_blocked: 'आपके खाते को अस्थायी रूप से ब्लॉक कर दिया गया है।\nकृपया हमारे सपोर्ट से संपर्क करें ताकि स्थिति को स्पष्ट किया जा सके।',
      block_my_account: 'मेरा खाता ब्लॉक करें',
      delete_account: 'खाता हटा दो',
      delete_my_account: 'मेरा एकाउंट हटा दो',
      sessions: 'सत्र',
      close_all_sessions: 'सभी सत्र बंद करें',
      current_session: 'वर्तमान सत्र',
      active_sessions: 'सक्रिय सत्र',
      no_other_sessions: 'कोई अन्य सत्र नहीं',
      removed: 'निकाला गया',
      online: 'ऑनलाइन',
      api_key: 'API कुंजी',
      api_key_not_available: 'एपीआई कुंजी इसके निर्माण के दौरान केवल एक बार दिखाई देती है',
      sensitive_hidden: 'छिपी हुई संवेदनशील जानकारी',
      ip_whitelist: 'आईपी ​​श्वेतसूची',
      add_ip_to_whitelist: 'श्वेतसूची में आईपी जोड़ें',
      disable_api_confirm: 'API एक्सेस को अक्षम करने की पुष्टि करें',
      disable_api_content: 'क्या आप वाकई अपने खाते के लिए API एक्सेस अक्षम करना चाहते हैं?',
    },
    store: {
      my_store: 'मेरी दुकान',
      store: 'दुकान',
      store_url: 'दुकान URL',
      store_alias: 'स्टोर उपनाम',
      id_store: 'ID स्टोर',
      hide_store: 'अपना स्टोर पेज छुपाएं',
      url_copied: 'स्टोर यूआरएल कॉपी किया गया',
      total_items: 'कुल सामान:',
      games: 'खेल:',
    },
    setting: {
      account_email: 'खाता ई - मेल',
      update_email: 'ईमेल अपडेट करें',
      setup_email: 'ईमेल सेटअप करें',
      update_password: 'पासवर्ड अपडेट करें',
      set_password: 'सांकेतिक शब्द लगना',
      enter_current_password: 'वर्तमान पासवर्ड दर्ज करें',
      password_changed: 'पासवर्ड बदला गया',
      current_password: 'वर्तमान पासवर्ड',
      enter_new_password: 'नया पासवर्ड दर्ज करें',
      repeat_new_password: 'नया पासवर्ड दोहराएँ',
      save_new_password: 'नया पासवर्ड सेव करें',
      new_password: 'नया पासवर्ड',
      repeat_password: 'पासवर्ड दोहराएं',
      account_2fa: 'खाता 2FA',
      enable_2fa: '2FA सक्षम करें',
      disable_2fa: '2FA अक्षम करें',
    },
    transaction: {
      amount: 'मात्रा',
      type: 'प्रकार',
      details: 'विवरण',
      fee: 'शुल्क',
      buyer_country: 'क्रेता देश',
      seller_country: 'विक्रेता देश',
      price: 'कीमत',
      item_name: 'आइटम नाम',
      transaction_history: 'ट्रांजेक्शन इतिहास',
      operation: 'संचालन',
      trade_id: 'ट्रेड आईडी',
      loading_trade_offers: 'व्यापार प्रस्ताव लोड हो रहे हैं',
      no_trades_found: 'कोई व्यापार प्रस्ताव नहीं मिला',
      id: 'पहचान',
      date: 'तारीख',
      game: 'खेल',
      items: 'सामान',
      status: 'स्थिति',
      time_left: 'शेष समय',
      action: 'कार्रवाई',
      trades_active: 'व्यापार सक्रिय',
      trades_history: 'व्यापार इतिहास',
      balance: 'संतुलन',
      history: 'लेन-देन का इतिहास',
      pending: 'लम्बित लेन - देन',
      reports: 'निर्यात की गई रिपोर्टें',
      active_locks: 'सक्रिय ताले',
      export: 'निर्यात',
      export_to_csv: '.CSV पर निर्यात करें',
      export_description: 'वह महीना और वर्ष चुनें जिसके लिए आप रिपोर्ट तैयार करना चाहते हैं।',
      the_report_will_appear_in_the: 'रिपोर्ट में दिखाई देगी',
      tab_once_the_export_process_is_complete: 'निर्यात प्रक्रिया पूरी होने पर टैब करें।',
    },
  },
  fee: {
    individual: 'व्यक्ति',
    individual_fee: 'व्यक्तिगत शुल्क',
    custom_sale_fee: 'आपका कस्टम बिक्री शुल्क',
    your_current_fees: 'आपकी वर्तमान फीस',
    high_tier: 'उच्च स्तरीय',
    fee: 'शुल्क',
    fee_up_to: 'शुल्क',
    sale_fee: 'बिक्री शुल्क',
    sales_fees: 'बिक्री शुल्क',
    see_all_levels: 'सभी स्तर देखें',
    you_are_on_the: 'आप पर हैं',
    maximum_sales_fee: 'अधिकतम बिक्री शुल्क: {value}',
    your_total_sale_volume: 'आपकी अब तक की कुल बिक्री मात्रा है',
    sales_fees_will_be_lowered: 'जैसे-जैसे आप अधिक वस्तुएँ बेचेंगे बिक्री शुल्क कम हो जाएगा।',
    level: 'स्तर',
    your_level: 'आपका स्तर:',
    progress: 'प्रगति:',
    max_level: 'सर्वोच्च स्तर',
    next_level: 'अगला स्तर:',
    total_income: 'कुल आय',
    total_revenue: 'कुल मुनाफा',
    sold_items: 'बेची गई वस्तुएं',
    page: {
      sales_fees_depends_on_two_factors: 'बिटस्किन्स पर <span class="text-cp">बिक्री शुल्क</span> दो कारकों पर निर्भर करता है:',
      the_price: '1. जिस कीमत पर आप अपना सामान बेच रहे हैं',
      the_listing_type: '2. लिस्टिंग प्रकार:',
      listing_type_public: 'सार्वजनिक - आपका आइटम वेबसाइट पर सभी उपयोगकर्ताओं को दिखाई देता है',
      listing_type_private: 'निजी - आपका आइटम केवल उन लोगों को दिखाई देता है जिनके साथ आप लिंक साझा करते हैं',
      fee_explanation: 'आप अपनी वस्तु को जितनी अधिक कीमत पर बेचेंगे, आपको बिक्री शुल्क उतना ही कम देना होगा। मानक बिक्री शुल्क 2.5% (निजी लिस्टिंग के लिए) से अधिकतम 10% (सार्वजनिक लिस्टिंग के लिए) है। इसके अलावा, हमारे पास 5 अलग-अलग बिक्री स्तर हैं जो आपको अपनी बिक्री शुल्क को और भी कम करने की अनुमति देते हैं। नियम सरल है - जितना अधिक आप बेचेंगे, उतनी कम बिक्री शुल्क का भुगतान करेंगे। आप अपनी बिक्री शुल्क को 2.4% (निजी लिस्टिंग के लिए) या 9.8% (सार्वजनिक लिस्टिंग के लिए) तक कम कर सकते हैं। हमारी शुल्क प्रणाली पारदर्शी है और इसमें कोई छिपी हुई फीस नहीं है।',
      default_sales_fees_title: 'डिफ़ॉल्ट बिक्री शुल्क',
      default_sale_fees_description: 'यदि आप अभी शुरुआत कर रहे हैं और आपने अभी तक कोई वस्तु नहीं बेची है तो आपकी बिक्री शुल्क इस प्रकार होगी:',
      how_to_reduce_my_sales_fees_title: 'मैं अपना विक्रय शुल्क कैसे कम करूँ?',
      how_to_reduce_my_sales_fees_description: 'BitSkins पर हमारे पास 5 बिक्री स्तर हैं। उनमें से प्रत्येक (स्तर 1 को छोड़कर) आपके बिक्री शुल्क को 0.05% कम कर देता है। अपने स्तर को उन्नत करने के लिए, आपको एक निश्चित मूल्य सीमा पर आइटम बेचने की आवश्यकता है।',
      sales_fees_levels: 'बिक्री शुल्क स्तर',
      price_range: 'मूल्य सीमा',
      total_sales: 'कुल बिक्री',
      fee_reduced_by: 'फीस कम की गई',
      individual_sales_fees_title: 'व्यक्तिगत बिक्री शुल्क',
      individual_sales_fees_description: 'यदि आप सक्रिय रूप से बिटस्किन्स का उपयोग कर रहे हैं और आपका मासिक कारोबार कम से कम<span class="span text-csfl6"> {amount}</span> है, तो हमसे संपर्क करने में संकोच न करें। हम आपको इससे भी कम बिक्री शुल्क और अतिरिक्त सहायता की पेशकश कर सकते हैं।',
    },
  },
  copy: {
    text_copied: 'पाठ कॉपी किया गया',
    cannot_copy: 'नकल नहीं कर सकता',
    name_copied: 'नाम कॉपी किया गया',
    cannot_copy_name: 'नाम की प्रतिलिपि नहीं बनाई जा सकती',
    copy_link: 'लिंक की प्रतिलिपि करें',
  },
  share: {
    share_on_twitter: 'ट्विटर पर साझा करें',
    share_on_facebook: 'फेसबुक पर सांझा करें',
    share_on_telegram: 'टेलीग्राम पर साझा करें',
  },
  discord: {
    discord: 'डिस्कॉर्ड',
    already_connected: 'पहले से ही कनेक्टेड',
    something_went_wrong: 'कुछ गलत हो गया',
    success: 'सफलता!',
    loading: 'लोड हो रहा है...',
    connect_with_discord: 'डिस्कॉर्ड से जुड़ें',
  },
  telegram: {
    already_connected: 'पहले से ही कनेक्टेड',
    something_went_wrong: 'कुछ गलत हो गया',
    success: 'सफलता!',
    loading: 'लोड हो रहा है...',
  },
  error: {
    error_404: 'त्रुटि 404',
    page_not_found: 'पृष्ठ नहीं मिला',
  },
  kyc: {
    description_1: 'अपनी वेबसाइट के माध्यम से की जाने वाली लेनदेनों की सुरक्षा सुनिश्चित करने और प्रयोज्य AML/KYC नियमों का पालन करने के लिए, हमें आपसे डेटा सत्यापन प्रक्रिया (KYC) का अनुभव करने की आवश्यकता होती है। यहां तीन सत्यापन स्तर हैं। प्रत्येक स्तर लिमिट बढ़ाता है या पूरी तरह से हटा देता है और आपको नए भुगतान विधियों तक पहुंच प्रदान करता है।',
    description_2_start: 'आपकी KYC सत्यापन प्रक्रिया के बारे में विस्तृत नियम और शर्तें हमारी सेवा की शर्तों में वर्णित की गई हैं। हम आपको आश्वासन देना चाहेंगे कि आप द्वारा प्रदान की गई सभी डेटा का उपयोग उसी के अनुसार होगा।',
    description_2_end: 'केवाईसी सत्यापन प्रक्रिया की शुरुआत करके, आप हमारे द्वारा आपके डेटा के संसाधित करने की अनुमति देते हैं जो कानूनी तर्क से न्यायित उद्देश्यों के लिए है।',
    personal_data: 'व्यक्तिगत डेटा',
    first_name: 'पहला नाम',
    middle_name: 'मध्य नाम',
    last_name: 'उपनाम',
    street_name: 'सड़क का नाम',
    street_number: 'गली संख्या',
    postal_code: 'डाक कोड',
    city: 'शहर',
    province: 'प्रांत',
    country: 'देश',
    start_kyc_verification: 'शुरू करें KYC सत्यापन',
    upload: 'डालना',
    uploaded: 'अपलोड किए गए',
    image_uploaded: 'छवि अपलोड की गई',
    document_type: {
      id: 'ID',
      driving_license: 'ड्राइविंग लाइसेंस',
      passport: 'पासपोर्ट',
      other: 'अन्य',
    },
    limit: {
      crypto_withdraw: 'वार्षिक क्रिप्टो निकासी सीमा {amount}',
      crypto_withdraw_unlimited: 'असीमित क्रिप्टो निकासी',
      non_crypto_withdraw: 'वार्षिक गैर-क्रिप्टो निकासी सीमा {amount} हैं।',
      non_crypto_withdraw_unlimited: 'असीमित गैर-क्रिप्टो निकासी',
      crypto_deposit: 'वार्षिक क्रिप्टो जमा सीमा {amount}',
      crypto_deposit_unlimited: 'असीमित क्रिप्टो जमा',
      non_crypto_deposit: '{amount} की वार्षिक गैर-क्रिप्टो जमा सीमा',
      non_crypto_deposit_unlimited: 'असीमित गैर-क्रिप्टो जमा',
    },
    your_kyc_verification: 'आपकी KYC सत्यापन',
    your_kyc_needs_an_update: 'आपकी KYC को अपडेट की आवश्यकता है।',
    need_update_reason: 'दुर्भाग्य से हम आपके खाते को मंजूरी देने में सक्षम नहीं थे निम्नलिखित कारणों के कारण:',
    open_support: 'खुला समर्थन',
    your_kyc_has_been_denied: 'आपका KYC <span class="color-denied">मन्जूर नहीं किया गया है</span>',
    denied_description: 'आपका KYC मन्जूर नहीं हुआ है, इसलिए आप KYC सत्यापन के माध्यम से फिर से नहीं जा सकते।',
    deleted_description: 'आपका KYC मन्य कर दिया गया है। आप पुनः सत्यापन प्रक्रिया के माध्यम से जा सकते हैं।',
    please_contact_our: 'कृपया हमसे संपर्क करें',
    support: 'सहायता',
    clarify_the_situation: 'स्थिति स्पष्ट करने के लिए.',
    your: 'आपका',
    kyc_title: 'अपने ग्राहक को जानें <span class="text-cp">सत्यापन</span>',
    verification: 'प्रमाणीकरण',
    pending: 'अपूर्ण है',
    pending_description: 'यह सब है! सत्यापन प्रक्रिया के माध्यम से जाने के लिए धन्यवाद। आपका डेटा सफलतापूर्वक सबमिट किया गया है। हम जितनी जल्दी हो सके आपके आवेदन की जांच करने की कोशिश करेंगे। आमतौर पर यह 12 घंटे से अधिक नहीं लेता। आपके खाते को मंजूरी मिलने पर हम आपको ईमेल करेंगे। आपकी सहनशीलता की कद्र की जाती है।',
    do_you_need_help: 'क्या आपको मदद की ज़रूरत है? कृपया हमसे संपर्क करें',
    support_center: 'सहायता केंद्र',
    back_to_kyc: 'केवाईसी पर वापस जाएं',
    go_to_home: 'घर जाओ',
    level_0: 'स्तर 0',
    level_1: 'स्तर 1',
    level_2: 'स्तर 2',
    limits: 'सीमाएं',
    benefits: 'फ़ायदे',
    requirements: 'आवश्यकताएं',
    no_requirements: 'कोई आवश्यकता नहीं',
    proof_of_address: 'पते का प्रमाण',
    all_benefits_from_the_basic_level: 'सभी लाभ बुनियादी स्तर से',
    personal_information: 'व्यक्तिगत जानकारी',
    identity_document: 'पहचान दस्तावेज़',
    selfie: 'सेल्फी',
    all_benefits_from_level_1: 'लेवल 1 से सभी लाभ',
    current: 'मौजूदा',
    upending: 'लंबित',
    update: 'अद्यतन',
    verification_blocked: 'सत्यापन अवरुद्ध',
    verify_now: 'अभी सत्यापित करें',
    you_need_to_upgrade_to_level_1: 'आपको लेवल 1 में अपग्रेड करना होगा',
    upgrade_to_level_1: 'लेवल 1 पर अपग्रेड करें',
    upgrade_to_level_2: 'लेवल 2 पर अपग्रेड करें',
    kyc_verification: 'KYC सत्यापन',
    kyc_verification_span: 'KYC सत्यापन',
    kyc_verification_required: 'KYC सत्यापन आवश्यक है',
    everything_done: 'सब कुछ हो गया!',
    proof_of_residency: 'निवास का प्रमाण',
    you_current_residential_address: 'आपका वर्तमान आवासीय पता',
    only_x_minutes: 'केवल {minutes} मिनट!',
    identity_verification: 'पहचान सत्यापन',
    take_a_selfie: 'एक स्वफ़ोटो ले',
    step: 'चरण {step}',
    country_of_residence: 'निवास का देश',
    full_name: 'पूरा नाम',
    date_of_birth: 'जन्म की तारीख',
    nationality: 'राष्ट्रीयता',
    choose_your_document: 'अपना दस्तावेज़ चुनें',
    choose_document_description_1: 'वह दस्तावेज़ चुनें जिसे आप सत्यापन के दौरान उपयोग करना चाहते हैं।',
    choose_document_description_2: 'हम केवल वैध सरकार द्वारा जारी दस्तावेज़ स्वीकार करते हैं।',
    choose_document_description_3: 'कोई भी अन्य दस्तावेज़ जो सूची में नहीं है, अस्वीकार कर दिया जाएगा.',
    document_number: 'दस्तावेज़ संख्या',
    country_of_issue: 'इस मसले से संबंधित देश',
    document_issue_date: 'दस्तावेज़ जारी करने की तारीख',
    document_expiry_date: 'दस्तावेज़ की समाप्ति तिथि',
    files_requirements: 'फ़ाइलें आवश्यकताएँ',
    format: '{format} या {or} प्रारूप',
    maximum_file_size: 'अधिकतम फ़ाइल आकार {size}',
    minimum_picture_size: 'न्यूनतम चित्र आकार {size} पिक्सेल',
    not_accepted_documents: 'दस्तावेज़ स्वीकार नहीं किए गए',
    expired: 'खत्म हो चुका',
    edited: 'संपादित',
    black_and_white: 'काला और सफेद',
    broken_or_damaged: 'टूटा हुआ या क्षतिग्रस्त',
    illegible_blurred_or_reflective: 'अस्पष्ट, धुंधला या प्रतिबिम्बित',
    cut_off_or_overcropped: 'कटा हुआ या अधिक काटा हुआ',
    upload_front_page: 'फ्रंट पेज अपलोड करें',
    upload_back_page: 'पिछला पृष्ठ अपलोड करें',
    selfie_description: 'कृपया अपनी ID और अपना नाम, "BitSkins.com" टेक्स्ट और आज की तारीख वाला एक कागज पकड़े हुए अपनी एक तस्वीर अपलोड करें।',
    example_of_correctly_taken_photo: 'सही ढंग से ली गई तस्वीर का एक उदाहरण',
    with_sunglasses_cap_or_mask: 'धूप का चश्मा, टोपी या मास्क के साथ',
    information_covered_by_finger: 'आपके दस्तावेज़ की जानकारी आपकी उंगलियों से ढकी हुई है',
    face_covered_by_document: 'आपका चेहरा आपके दस्तावेज़ से ढका हुआ है',
    out_of_focus: 'आपका चेहरा या आपका दस्तावेज़ फ़ोकस से बाहर है',
    upload_selfie: 'सेल्फी अपलोड करें',
    send_level_1_kyc_request: 'लेवल 1 केवाईसी अनुरोध भेजें',
    address_line_1: 'पता पंक्ति 1',
    address_line_2_optional: 'पता पंक्ति 2 (वैकल्पिक)',
    state_or_province: 'राज्य या प्रांत',
    proof_of_residency_description: 'कृपया पिछले स्टेप में आपने दिए गए वर्तमान निवास पते को साबित करने वाले एक दस्तावेज़ अपलोड करें। यह सुनिश्चित करें कि दस्तावेज़ पर आपका पूरा नाम दिखाई देता है।',
    upload_document: 'दस्तावेज़ अपलोड करें',
    accepted_documents: 'स्वीकृत दस्तावेज़',
    utility_bills: 'उपयोगिता बिल',
    bank_statements: 'बैंक विवरण',
    tax_returns: 'कर विवरणी',
    government_letters: 'सरकारी पत्र',
    other_document_residential: 'अन्य दस्तावेज़ जो आपके वर्तमान आवासीय पते की पुष्टि करते हैं',
    send_level_2_kyc_request: 'लेवल 2 केवाईसी अनुरोध भेजें',
    submit: 'जमा करना',
    submit_correct: 'सही जानकारी सबमिट करें',
    next: 'अगला',
    send_to_verify: 'सत्यापित करने के लिए भेजें',
    document_verification: 'दस्तावेज़ सत्यापन',
    level: 'केवाईसी स्तर',
    please_reupload_following_photos: 'कृपया निम्नलिखित फ़ोटो पुनः अपलोड करें',
    please_reupload: 'कृपया पुनः अपलोड करें',
    we_need_additional_information: 'हमें अतिरिक्त जानकारी चाहिए',
    file_format_not_supported: 'यह फ़ाइल स्वरूप समर्थित नहीं है.',
    the_file_is_too_big: 'फ़ाइल {file_name} बहुत बड़ी है ({file_size}),<br> अधिकतम {size_limit}।',
    field: {
      document_image_a: 'आपके दस्तावेज़ का मुख पृष्ठ',
      document_image_b: 'आपके दस्तावेज़ का पिछला पृष्ठ',
      user_image: 'आपकी सेल्फी',
      address_image: 'निवास का प्रमाण',
      additional_selfie: 'अतिरिक्त सेल्फी',
    },
    back_to_bitskins: 'बिटस्किन्स पर वापस',
    withdrawals: 'निकासी',
    get_to_the_next_level: 'अपनी सीमाओं से छुटकारा पाने और नए भुगतान विधियों का उपयोग करने के लिए अगले स्तर तक पहुंचें।',
    after_the_first_page_is_validated: 'पहली फ़ोटो को सत्यापित करने के बाद आप दूसरे पृष्ठ को अपलोड कर सकेंगे।',
    accepted: 'स्वीकृत',
  },
  camera: {
    cancel: 'रद्द करना',
    check_permissions: 'अनुमतियाँ जांचें',
    take_a_new_photo: 'एक नई फ़ोटो लें',
    take_a_photo: 'एक तस्वीर लें',
    use_camera: 'कैमरे का प्रयोग करें',
    use_photo: 'फोटो का प्रयोग करें',
    we_will_need_access_to_your_camera: 'जारी रखने के लिए हमें आपके कैमरे तक पहुंच की आवश्यकता होगी।',
    please_follow_these_steps: 'कृपया इन चरणों का पालन करें',
    select_the_camera_icon: 'अपने पता बार में <strong>कैमरा आइकन</strong> को चुनें',
    select_always_allow_access: 'हमेशा अपने कैमरे तक पहुंच की अनुमति देने का चयन करें',
    select_done: 'चुनें विनामूल्य',
  },
  review: {
    leave_a_review: 'समीक्षा लिखें',
    our_reviews: 'हमारी समीक्षाएँ',
    if_youre_happy: 'यदि आप सेवा के बारे में खुश हैं,',
    we_would_appreciate: 'हमें अत्यंत प्रसन्नता होगी अगर आप हमें एक समीक्षा छोड़कर अपने अनुभव को साझा करें Trustpilot पर हमारी मदद करने के लिए। धन्यवाद!',
    if_youre_happy_we_would_appreciate: 'यदि आप सेवा के बारे में खुश हैं, तो हमें यह सराहना होगी कि आप हमें आपके अनुभव को साझा करके हमारी मदद करने के लिए Trustpilot पर समीक्षा छोड़ें। धन्यवाद!',
  },
  support: {
    center: 'सहायता केंद्र',
    tickets_list: 'टिकट सूची',
    create_ticket: 'टिकट बनाएं',
    submit_ticket: 'टिकट सबमिट करें',
    close_ticket: 'टिकट बंद करें',
    submit_disclaimer: 'अपने काम की गति को तेज़ करने और जितना संभव हो सके जल्दी जवाब प्राप्त करने के लिए, सुनिश्चित करें कि आप एक ही मुद्दे के संबंध में कई टिकट नहीं खोलते हैं। औसत प्रतिक्रिया समय कई घंटे है। आप हमसे <strong>अंग्रेज़ी, पोलिश और स्वीडिश</strong> में संपर्क कर सकते हैं। आपके सहयोग के लिए धन्यवाद।',
    enter_your_message: 'अपना संदेश दर्ज करें',
    new_ticket: 'नया टिकट',
    your_ticket: 'आपका टिकट',
    bitskins_team: 'बिटस्किन्स टीम',
    ticket_has_been_closed_by: 'टिकट को बंद कर दिया गया है <span>{by}</span> द्वारा।',
    ticket_has_been_closed: 'टिकट बंद कर दिया गया है।',
    conversation_history: 'बातचीत का इतिहास:',
    your_reply: 'आपके उत्तर...',
    last_reply_by: 'द्वारा अंतिम उत्तर',
    send: 'भेजना',
    ticket: 'टिकट',
    title: 'शीर्षक',
    category: {
      payments: 'भुगतान',
      payment_crypto_deposit: 'क्रिप्टो जमा',
      payment_crypto_withdraw: 'क्रिप्टो वापसी',
      payment_standard_deposit: 'मानक जमा विधि',
      payment_standard_withdraw: 'मानक निकासी विधि',
      market: 'बाज़ार',
      market_item_issue: 'आइटम मुद्दा',
      market_buy_orders: 'ऑर्डर खरीदें',
      market_bulk_buy: 'थोक खरीद',
      market_missing_screenshot: 'अनुपलब्ध स्क्रीनशॉट',
      market_missing_float: 'लापता फ्लोट',
      market_wrong_price: 'गलत स्टीम कीमत',
      market_other: 'अन्य',
      trading: 'ट्रेडों',
      trading_deposit: 'वस्तु जमा',
      trading_withdraw: 'आइटम वापस लेना',
      account: 'खाता',
      account_2fa: '2एफए मुद्दा',
      account_email: 'ईमेल मुद्दा',
      account_kyc: 'KYC',
      account_affiliate: 'संबद्ध प्रणाली',
      account_restrictions: 'प्रतिबंध',
      account_other: 'अन्य',
      other: 'अन्य',
      bug_report: 'बग रिपोर्ट',
      api: 'API',
      suggestions: 'सुझाव',
      business_inquiry: 'व्यापार जांच',
      general_inquiry: 'सामान्य पूछताछ',
    },
    extra: {
      txid_url: 'TXID/url',
      amount: 'राशि',
      crypto: 'cryptocurrency',
      disclaimer_visa_1: 'कृपया ध्यान दें, आपके बैंक खाते में पैसे उपलब्ध होने में लगभग 5 व्यापारिक दिन लग सकते हैं।',
      disclaimer_visa_2: 'कृपया सुनिश्चित करें कि आप निकासी करने की कोशिश कर रहे हैं, यह वीज़ा है और मास्टरकार्ड नहीं। हम वर्तमान में मास्टरकार्ड निकासियों का समर्थन नहीं करते हैं।',
      card_digits: 'आपके कार्ड के 4 अंतिम अंक',
      binance_id: 'आपकी बायनेन्स आईडी',
      wallet_address: 'बटुआ पता',
      provider: 'प्रदाता',
      transaction_id: 'लेन-देन आईडी',
      type: 'प्रकार',
      method: 'तरीका',
      item_link: 'आइटम से लिंक करें',
      bot_received_item: 'आपके आइटम प्राप्त करने वाले बॉट के स्टीम प्रोफ़ाइल का एक लिंक',
      trade_offer_id: 'व्यापार प्रस्ताव की आईडी',
      can_be_found_here: 'यहां मिल सकता है।',
      email: 'ईमेल दर्ज करें',
    },
  },
  service: {
    market: {
      buy: 'खरीदना',
      sell: 'बेचना',
      fee: 'बिक्री शुल्क',
      buy_order: 'ऑर्डर खरीदें',
      bargain: 'सौदा',
      instant_sell: 'तुरंत बिक्री',
      bump: 'उभार',
      bump_package: 'बम्प पैकेज',
    },
    deposit: {
      gift_code: 'गिफ़्ट कोड',
      bitcoin: 'BTC जमा करें',
      litecoin: 'LTC जमा करें',
      ethereum: 'ETH जमा करें',
      unlimint: 'बैंक कार्ड से जमा करें',
      binance_pay: 'बिनेंस पे के साथ जमा करें',
      binancepay: 'बिनेंस पे के साथ जमा करें',
      available_coupons: 'उपलब्ध कूपन:',
      redeem_coupon: 'कूपन रिडीम कराएं',
      enter_coupon_code: 'परचा कूट दर्ज करें',
      open_binance_website: 'बिनेंस वेबसाइट खोलें',
      list_of_active_transactions: 'सक्रिय लेनदेन की सूची:',
      transaction_needs_at_least_x_confirmations: 'खाते में फंड दिखाई देने से पहले लेनदेन को कम से कम {x} पुष्टिकरण की आवश्यकता होती है।',
      billing_information: 'बिलिंग जानकारी',
      coupon: {
        coupon: 'कूपन',
        make_a_gift: 'खुद को या किसी और को उपहार बनाएं',
        bitskins_coupons_are_a_good_alternative: 'BitSkins कूपन के सामान्य भुगतान विधियों के एक अच्छे विकल्प हैं और यह एक शानदार उपहार विचार है। आप इन्हें हमारे साथी की पार्टनर्स से खरीद सकते हैं जो कई भुगतान विधियाँ प्रदान करते हैं।',
        dont_wait: '<span class="text-cp">इंतजार न करें और अपने बैलेंस को टॉप अप करें</span> एक बिटस्किन्स कूपन के साथ या किसी को भेजें <br><span class="text-cp">एक मूल उपहार</span> (हम सभी जानते हैं कि किसी के पास खाली इंवेंट्री वाला व्यक्ति होता है)।',
        kinguin: 'किंगुइन (नई कम फीस)',
      },
      crypto: {
        get_wallet_address: 'बटुए का पता प्राप्त करें',
        your_wallet_address: 'आपका बटुआ पता',
        this_address_is_only_for_x: 'यह पता केवल {x} जमा के लिए है। कृपया इस पते पर किसी अन्य क्रिप्टो को न भेजें।',
        this_address_will_not_expire: 'यह पता कभी समाप्त नहीं होगा। आप इसे कभी भी उपयोग कर सकते हैं।',
        choose_alternative_address: 'वैकल्पिक पता चुनें',
        the_acutal_amount_you_will_be_credited: 'आपके भुगतान प्राप्त करने के समय {x} मूल्य पर आपको ग्राह्य राशि निर्धारित की जाएगी।',
        only_l1_transactions: 'केवल L1 लेनदेन समर्थित हैं। आंतरिक लेनदेन और स्मार्ट कॉन्ट्रैक्ट का उपयोग न करें!',
      },
      zen: {
        zen: 'ज़ेन के पास जमा करें',
        deposit_started: 'ZEN जमा शुरू हुआ,',
        open_the_zen_deposit_page: 'ज़ेन जमा पृष्ठ खोलें',
        processing_fee: 'ZEN ट्रांजैक्शन पर प्रसंस्करण शुल्क जो चयनित भुगतान विधि पर निर्भर करेगा, जोड़ेंगे।<br> अंतिम लेनदेन राशि उनकी वेबसाइट पर दिखाई देगी।',
        each_transaction_is_reviewed: 'प्रत्येक लेनदेन को ZEN Pay द्वारा समीक्षित किया जाता है और पूरा होने में एक मिनट से कुछ घंटे लग सकते हैं।',
      },
      the_minimum_deposit_amount_is: 'न्यूनतम जमा राशि {amount} है.',
      the_maximum_deposit_amount_is: 'अधिकतम जमा राशि {amount} है.',
    },
    withdraw: {
      only_binance_com_is_supported: 'हम केवल binance.com को ही भुगतान करते हैं (binance.us का समर्थन नहीं किया जाता है)।',
      bitcoin: 'BTC वापस लें',
      litecoin: 'LTC वापस लें',
      ethereum: 'ETH वापस लें',
      unlimint: 'VISA कार्ड से निकासी',
      tipalti: {
        tipalti: 'टिपल्टी के साथ वापस लें',
        tipalti_allows_you_to_withdraw: 'Tipalti आपको अपने फंड को अपने बैंक और PayPal खाते में निकालने की अनुमति देता है।',
        you_dont_have_a_tipalti_acount: 'आपके पास एक टिपाल्टी खाता नहीं है?',
        you_have_to_create_an_account: 'अपने फंड्स को Tipalti के माध्यम से निकालने के लिए पहले आपको उनकी वेबसाइट पर एक खाता बनाना होगा।<br> आप इसे नीचे दिए गए बटन पर क्लिक करके कर सकते हैं।',
        create_tipalti_account: 'टिपल्टी खाता बनाएं',
        check_your_email: 'कृपया अपने ईमेल इनबॉक्स की जांच करें और खाता सृजन प्रक्रिया को पूरा करने के लिए पुष्टिकरण लिंक पर क्लिक करें। यदि आप अपने इनबॉक्स में ईमेल संदेश नहीं ढूंढ पा रहे हैं, तो कृपया अपने स्पैम फ़ोल्डर की जांच करें।',
        payment_method: 'भुगतान विधि',
        tipalti_panel: 'टिपल्टी पैनल',
        tipalti_payouts_incur_a_fee: 'Tipalti payouts का एक शुल्क होता है जो $26 तक हो सकता है। शुल्क चयनित भुगतान विधि पर निर्भर करता है। नीचे आप प्रत्येक भुगतान विधि के लिए शुल्क के साथ एक तालिका पा सकते हैं।',
        fee_per_payment: 'प्रति भुगतान शुल्क',
        rejection_fee: 'अस्वीकृति शुल्क',
        echeck_local: 'ईचेक (स्थानीय)',
        paypal_non_us: 'पेपैल (गैर-अमेरिकी निवासी)',
        paypal_us: 'पेपैल (अमेरिका निवासी)',
        wire_transfer_non_us_non_usd: 'वायर ट्रांसफ़र (गैर-अमेरिकी निवासी को गैर-यूएसडी में भुगतान)',
        wire_transfer_non_us_usd: 'वायर ट्रांसफ़र (गैर-अमेरिकी निवासी को USD में भुगतान)',
        wire_transfer_us: 'वायर ट्रांसफ़र (अमेरिका निवासी)',
        up_to_21_usd: '$21.00 तक',
        up_to_2_usd: '$2.00 तक',
      },
      payoneer: 'Payoneer से निकासी करें',
      binance_pay: 'बिनेंस पे के साथ निकासी करें',
      binancepay: 'बिनेंस पे के साथ निकासी करें',
      p2p: 'पी2पी स्थानांतरण',
      payouts_are_performed_on_a_rolling_basis: 'अनुरोध किए जाने के बाद 5 मिनट तक रोलिंग आधार पर भुगतान किया जाता है।',
      your_payout_will_be_processed_at_the_current_rate: 'आपका भुगतान वर्तमान दर पर संसाधित किया जाएगा।',
      please_verify_the_wallet_address: 'कृपया बटुए का पता सत्यापित करें. गलत निकासी पर हम रिफंड नहीं कर सकते।',
      the_data_controller: 'उन्लिमिंट के साथ भुगतान कार्यपालक द्वारा प्रसंस्कृत भुगतानों के संबंध में डेटा नियंत्रक और संविष्टित पक्ष बिटस्किन्स एसपी जेड ओ.ओ. है, जिसका पंजीकृत कार्यालय 40-246 कटोविस, पोर्सेलेनोवा सड़क 23, पोलैंड है, जिसका नंबर है: 0000810143 - अधिक विवरण गोपनीयता नीति और टीओएस में दिए गए हैं।',
      visa_withdrawals_are_processed_instantly: 'VISA वापसी को तुरंत प्रसंस्कृत किया जाता है। हालांकि, कुछ मामलों में पैसे आपके बैंक खाते में दिखाई देने से पहले कई दिनों तक लग सकते हैं।',
      card_info: 'कार्ड की जानकारी',
      ccv: 'CCV',
      add_new_deposit_needed: 'नया जोड़ें (जमा आवश्यक)',
      you_can_have_max_3_bank_cards: 'आपके खाते को तीन बैंक कार्डों से अधिक नहीं जोड़ा जा सकता है।',
      your_cards_amount: '<text_to_translate><span class="text-cp">तुम्हारे</span> कार्ड ({x}/3)</text_to_translate>',
      the_minimum_withdraw_amount_is_x: 'न्यूनतम निकासी राशि {x} है.',
      the_maximum_withdraw_amount_is_x: 'अधिकतम निकासी राशि {x} है.',
      enter_amount: 'राशि डालें',
      go_to_card_deposit: 'कार्ड डिपॉज़िट पर जाएँ',
      to_be_able_to_withdraw_your_funds_you_need_to_verify_your_card: 'अपनी धनराशि निकालने में सक्षम होने के लिए आपको पहले अपना कार्ड सत्यापित करना होगा। आप इसे $1 जमा करके कर सकते हैं.',
      deposited_funds_are_non_withdrawable: 'कृपया ध्यान रखें कि जमा की गई धनराशि निकासी योग्य नहीं है और इसका उपयोग केवल खरीदारी के लिए किया जा सकता है।',
      we_do_not_support_mastercard_withdrawals: 'हम मास्टरकार्ड कार्ड और निम्नलिखित देशों में जारी की गई कार्डों को निकासी का समर्थन नहीं करते हैं: बोस्निया और हर्ज़ेगोविना, कनाडा, मिस्र, जापान, कंबोडिया, कोरिया (गणराज्य), कोसोवो, उत्तर मैसेडोनिया, संयुक्त राज्य अमेरिका, अर्जेंटीना.',
      your_card_is_valid_until: 'आपका कार्ड 16.02.2023, 15:35 (UTC) तक वैध है। इस समय के बाद आपको $5 जमा करके अपने कार्ड को दोबारा सत्यापित करना होगा।',
      card_verification_required: 'कार्ड सत्यापन आवश्यक है',
      card: 'कार्ड',
      add_new_card: 'नया कार्ड जोड़ें',
      how_to_find_my_binance_id: 'मेरा बिनेंस पर यूज़र आईडी (BUID) कैसे पता करें?',
      how_to_find_my_pay_id: 'बायनेन्स पर अपनी पे आईडी कैसे खोजें?',
      how_to_find_my_email: 'बायनेन्स पर अपना ईमेल कैसे खोजें?',
      binance_id: 'बायनेन्स आईडी',
      receiver_type: 'रिसीवर प्रकार',
      i_do_not_have_a_binance_account: 'मेरे पास बिनेंस खाता नहीं है',
      i_have_a_binance_account: 'मेरे पास एक बिनेंस खाता है',
      binance_account: 'बायनेन्स खाता',
      the_fee_is_already_included_in_the_current_x_rate: 'वर्तमान {x} दर में {fee}% फीस पहले से ही शामिल है।',
    },
    wallet: {
      transfer: 'पैसा भेजना',
      refund: 'धनराशि वापसी',
      available_payment_methods: 'उपलब्ध भुगतान विधियाँ',
      bank_cards: 'बैंक कार्ड',
      kyc_required_for_this_payment_method: 'आप इस भुगतान विधि का उपयोग नहीं कर सकते क्योंकि आपने KYC प्रक्रिया से नहीं गुजारा है। आप अब सत्यापन प्रक्रिया शुरू कर सकते हैं।',
      kyc_limit_exceeded: 'आप इस भुगतान विधि का उपयोग नहीं कर सकते क्योंकि आपने अपने KYC स्तर के लिए लेनदेन सीमा को पार कर दिया है। आप अब प्रमाणीकरण प्रक्रिया शुरू कर सकते हैं ताकि प्रतिबंधों को हटा सकें।',
      no_limit: 'कोई सीमा नहीं',
      limits_info: 'Bitskins पर प्रत्येक लेन-देन के लिए अपना टाइमर और सीमा होती है, जो लेन-देन के एक साल बाद रीसेट होती है। चार्ट में दिखाए गए अधिकतम राशि हैं जिन्हें आप जमा या निकासी कर सकते हैं। आप KYC प्रक्रिया के माध्यम से सीमाओं को बढ़ा सकते हैं या पूरी तरह से उनसे छुटकारा पा सकते हैं।',
      crypto_deposits: 'क्रिप्टो जमा',
      crypto_withdrawals: 'क्रिप्टो निकासी',
      standard_deposits: 'मानक जमा',
      standard_withdrawals: 'मानक जमा',
      coupons_are_excluded_from_the_limit: '* कूपन को सीमा से बाहर रखा गया है',
      x_type_does_not_incur_any_fees: '{x} {type} किसी भी शुल्क का भुगतान नहीं करता है.',
      incur_fees_of: 'की फीस लगती है',
      plus: 'प्लस',
      the_minimum_type_amount_is: 'न्यूनतम {type} राशि है',
      the_maximum_type_amount_is: 'अधिकतम {type} राशि है',
      due_to_unstable_crypto_network: 'अस्थिर क्रिप्टो नेटवर्क के कारण आपको कुछ देरी का अनुभव हो सकता है।',
      binance_temporarily_disabled: 'बिनेंस निकासी सोमवार (28.08.2023) तक अक्षम है',
    },
  },
  enum: {
    report_type: {
      balance: 'संतुलन',
      sell: 'बिका हुआ',
      buy: 'खरीदा',
    },
    report_status: {
      empty: 'खाली',
      pending: 'लंबित',
      done: 'हो गया',
    },
    autobump_period: {
      hour_1: '1 घंटे',
      hour_3: '3 घंटे',
      hour_6: '6 घंटे',
      hour_12: '12 घंटे',
      hour_24: '24 घंटे',
      hour_48: '48 घंटे',
    },
    autobump_status: {
      not_enough_bumps: 'पर्याप्त उभार नहीं',
      finished: 'खत्म',
      cancelled: 'रद्द',
      pending: 'लंबित',
      active: 'सक्रिय',
    },
    inventory_status: {
      issue: 'मुद्दा',
      not_available: 'उपलब्ध नहीं है',
      deleted: 'हटाए',
      withdrawn: 'वापस लिया गया',
      delisted: 'हटाए',
      ready: 'तैयार',
      listed: 'सूचीबद्ध',
      listed_private: 'निजी सूचीबद्ध',
      sold: 'बिका हुआ',
      withdraw_queue: 'कतार हटाओ',
      withdraw_pending: 'निकासी लंबित है',
      instant_sell: 'तुरंत बिक्री',
    },
    service: {
      market: {
        buy: 'खरीदना',
        sell: 'बेचना',
        fee: 'बिक्री शुल्क',
        buy_order: 'ऑर्डर खरीदें',
        bargain: 'सौदा',
        instant_sell: 'तुरंत बिक्री',
        bump: 'उभार',
        bump_package: 'बम्प पैकेज',
      },
      deposit: {
        bitcoin: 'BTC जमा करें',
        litecoin: 'LTC जमा करें',
        ethereum: 'ETH जमा करें',
        unlimint: 'बैंक कार्ड से जमा करें',
        zen: 'ZEN जमा करें',
        gift_code: 'गिफ़्ट कोड',
        binancepay: 'बिनेंस पे के साथ जमा करें',
      },
      withdraw: {
        bitcoin: 'BTC वापस लें',
        litecoin: 'LTC वापस लें',
        ethereum: 'ETH वापस लें',
        unlimint: 'वीज़ा कार्ड से निकासी',
        tipalti: 'टिपल्टी के साथ वापस लें',
        payoneer: 'Payoneer से निकासी करें',
        binancepay: 'बिनेंस पे के साथ निकासी करें',
        p2p: 'P2P स्थानांतरण',
      },
      wallet: {
        transfer: 'पैसा भेजना',
        refund: 'धनराशि वापसी',
      },
      marketing: {
        coupon: 'कूपन',
        referral: 'रेफ़रल',
        affiliate: 'संबद्ध',
      },
    },
  },
  meta: {
    default_title: 'BitSkins 2024',
    default_description: 'BitSkins एक सुगम प्लेटफ़ॉर्म प्रदान करता है जहां आप अपने CS2, DOTA2, TF2, RUST आइटम खरीदने और बेचने के लिए उपयुक्त हो सकते हैं। बंदूकें, चाकू, दस्ताने और बहुत कुछ के विशाल चयन का अन्वेषण करें। आसानी से ट्रेड करने के लिए अब शामिल हों!',
    home_title: 'BitSkins.com - CS2 स्किन खरीदें और बेचें। तेज़, आसान और सुरक्षित ट्रेडिंग',
    home_description: 'BitSkins एक सुगम प्लेटफ़ॉर्म प्रदान करता है जहां आप अपने CS2, DOTA2, TF2, RUST आइटम खरीदने और बेचने के लिए उपयुक्तता प्राप्त कर सकते हैं। बंदूकें, चाकू, दस्ताने और अधिक के विस्तृत चयन का अन्वेषण करें। आसानी से व्यापार करने के लिए अभी शामिल हों!',
    support_title: 'बिटस्किन्स समर्थन: अपनी CS2 ट्रेडिंग आवश्यकताओं के लिए सहायता प्राप्त करें',
    support_description: 'अपने CS2 ट्रेडिंग के साथ मदद चाहिए? तत्पर सहायता के लिए BitSkins समर्थन पृष्ठ पर जाएं। हमारी टीम यहाँ है ताकि आपके प्रश्नों का समाधान करें, समस्याओं को हल करें, और मार्गदर्शन प्रदान करें।',
    item_title: '{item} - {game} स्किन्स | अपने इच्छित {game} आइटम्स खोजें और ट्रेड करें',
    item_description_csgo: 'BitSkins पर अपनी वांछित CS2 खाल खोजें और व्यापार करें। राइफल, चाकू, दस्ताने और बहुत कुछ के हमारे विशाल संग्रह का अन्वेषण करें। तुरंत खरीदें, बेचें या वापस लें। अभी ब्राउज़ करना प्रारंभ करें!',
    item_description_cs2: 'BitSkins पर अपनी वांछित CS2 खाल खोजें और व्यापार करें। राइफल, चाकू, दस्ताने और बहुत कुछ के हमारे विशाल संग्रह का अन्वेषण करें। तुरंत खरीदें, बेचें या वापस लें। अभी ब्राउज़ करना प्रारंभ करें!',
    item_description_dota2: 'BitSkins पर अपनी वांछित DOTA2 खाल खोजें और व्यापार करें। वार्ड, संगीत, बंडल और बहुत कुछ के हमारे विशाल संग्रह का अन्वेषण करें। तुरंत खरीदें, बेचें या वापस लें। अभी ब्राउज़ करना प्रारंभ करें!',
    item_description_tf2: 'BitSkins पर अपने वांछित TF2 आइटम खोजें और व्यापार करें। सौंदर्य प्रसाधनों, तानों, क्रेटों और बहुत कुछ के हमारे विशाल संग्रह का अन्वेषण करें। तुरंत खरीदें, बेचें या वापस लें। अभी ब्राउज़ करना प्रारंभ करें!',
    item_description_rust: 'BitSkins पर अपने वांछित RUST आइटम खोजें और व्यापार करें। कपड़ों, हथियारों, संसाधनों और बहुत कुछ के हमारे विशाल संग्रह का अन्वेषण करें। तुरंत खरीदें, बेचें या वापस लें। अभी ब्राउज़ करना प्रारंभ करें!',
    market_title: 'बिटस्किन्स मार्केट: आसानी से {game} आइटम खोजें और व्यापार करें',
    market_description_csgo: 'आसानी से CS2 वस्तुओं की एक विस्तृत श्रृंखला का पता लगाने और व्यापार करने के लिए BitSkins बाज़ार में प्रवेश करें। खाल, चाबियाँ, कैप्सूल और बहुत कुछ पर सर्वोत्तम सौदे खोजें। तुरंत खरीदें, बेचें या वापस लें।',
    market_description_cs2: 'आसानी से CS2 वस्तुओं की एक विस्तृत श्रृंखला का पता लगाने और व्यापार करने के लिए BitSkins बाज़ार में प्रवेश करें। खाल, चाबियाँ, कैप्सूल और बहुत कुछ पर सर्वोत्तम सौदे खोजें। तुरंत खरीदें, बेचें या वापस लें।',
    market_description_dota2: 'DOTA2 वस्तुओं की एक विस्तृत श्रृंखला को सहजता से तलाशने और व्यापार करने के लिए BitSkins बाज़ार में प्रवेश करें। वार्ड, संगीत, बंडल और बहुत कुछ पर सर्वोत्तम सौदे खोजें। तुरंत खरीदें, बेचें या वापस लें।',
    market_description_tf2: 'आसानी से TF2 वस्तुओं की एक विस्तृत श्रृंखला का पता लगाने और व्यापार करने के लिए BitSkins बाज़ार में प्रवेश करें। सौंदर्य प्रसाधनों, तानों, क्रेटों और अन्य चीज़ों पर सर्वोत्तम सौदे खोजें। तुरंत खरीदें, बेचें या वापस लें।',
    market_description_rust: 'आसानी से RUST वस्तुओं की एक विस्तृत श्रृंखला का पता लगाने और व्यापार करने के लिए BitSkins बाज़ार में प्रवेश करें। कपड़ों, हथियारों, संसाधनों और अन्य चीज़ों पर सर्वोत्तम सौदे खोजें। तुरंत खरीदें, बेचें या वापस लें।',
    market_item_title: 'बिटस्किन्स मार्केट: {skin} : {game} मार्केट',
    store_title: 'बिटस्किन्स उपयोगकर्ता स्टोर: {alias} - {game} आइटम शोकेस',
    store_description: 'आपके आइटम प्रदर्शित करने और बेचने के लिए BitSkins उपयोगकर्ता स्टोर। अपनी कीमतें निर्धारित करें, खरीदारों के साथ जुड़ें और व्यापारिक समुदाय में अपनी उपस्थिति स्थापित करें।',
    login_title: 'BitSkins लॉगिन: आपके CS2 ट्रेडिंग खाते तक सुरक्षित पहुंच',
    login_description: 'अपने BitSkins खाते में सुरक्षित रूप से लॉग इन करें। अपनी CS2 इन्वेंट्री तक पहुंचें, आइटम प्रबंधित करें, लेनदेन करें और एक सहज ट्रेडिंग अनुभव का आनंद लें।',
    steam_login_title: 'स्टीम के साथ साइन इन करें',
    profile_title: 'आपकी खाता सेटिंग',
    wallet_title: 'आपका BitSkins फंड',
    affiliate_title: 'BitSkins संबद्ध पैनल: रेफरल के लिए पुरस्कार अर्जित करें',
    affiliate_description: 'BitSkins संबद्ध कार्यक्रम में शामिल हों और त्वचा के प्रति उत्साही लोगों को रेफर करके पुरस्कार अर्जित करें। एक आकर्षक सहबद्ध कार्यक्रम से लाभ उठाएं, अपने रेफरल को ट्रैक करें और अपनी कमाई अधिकतम करें।',
    statistics_title: 'बिटस्किन्स बिक्री सांख्यिकी: बाजार के रुझान और अंतर्दृष्टि को उजागर करें',
    statistics_description: 'CS2 ट्रेडिंग रुझानों में मूल्यवान अंतर्दृष्टि प्राप्त करने के लिए बिटस्किन्स पर व्यापक आंकड़ों का अन्वेषण करें। अपनी ट्रेडिंग रणनीतियों को अनुकूलित करने के लिए बाज़ार डेटा, आइटम की लोकप्रियता और बहुत कुछ का विश्लेषण करें।',
    sales_fees_title: 'BitSkins बिक्री शुल्क: आपकी CS2 बिक्री के लिए पारदर्शी मूल्य निर्धारण',
    sales_fees_description: 'BitSkins बिक्री शुल्क संरचना की स्पष्ट समझ प्राप्त करें। हमारी पारदर्शी फीस आपकी CS2 बिक्री के लिए निष्पक्षता और सरलता सुनिश्चित करती है। और अधिक जानें।',
    checkout_title: 'बिटस्किन्स कार्ट: CS2 आइटम के लिए सुविधाजनक चेकआउट',
    checkout_description: 'BitSkins कार्ट के साथ अपने CS2 ट्रेडिंग अनुभव को सरल बनाएं। आसानी से अपने आइटम प्रबंधित करें, अपने ऑर्डर की समीक्षा करें और सुरक्षित चेकआउट के लिए आगे बढ़ें। आज ही एक निर्बाध ट्रेडिंग प्रक्रिया का आनंद लें!',
    steam_inventory_title: 'मेरा {game} स्टीम इन्वेंटरी',
    bs_inventory_title: 'मेरा {game} BitSkins इन्वेंटरी',
    selling_inventory_title: 'मेरा {game} सूचीबद्ध आइटम',
    buy_order_create_title: '{game} के लिए खरीद ऑर्डर बनाना',
    buy_order_active_title: '{game} के लिए सक्रिय खरीद ऑर्डर',
    buy_order_title: '{game} के लिए ऑर्डर खरीदें',
    trades_active_title: 'सक्रिय व्यापार',
    trades_history_title: 'व्यापार इतिहास',
    transactions_title: 'लेनदेन',
    favorites_title: 'पसंदीदा आइटम',
    kyc_title: 'अपने ग्राहक (KYC) आवेदन पत्र को जानें',
    tos_title: 'BitSkins उपयोग की शर्तें: सुरक्षित और विश्वसनीय ट्रेडिंग के लिए दिशानिर्देश',
    tos_description: 'सुरक्षित और विश्वसनीय व्यापार के लिए हमारी उपयोग की शर्तों की समीक्षा करें। हमारी नीतियों और दायित्वों से स्वयं को परिचित कराएं। BitSkins पर सुरक्षित रूप से व्यापार करें।',
    privacy_policy_title: 'BitSkins गोपनीयता नीति: आपकी व्यक्तिगत जानकारी की सुरक्षा करना',
    privacy_policy_description: 'यह जानने के लिए कि हम आपकी व्यक्तिगत जानकारी की सुरक्षा और प्रबंधन कैसे करते हैं, BitSkins गोपनीयता नीति पढ़ें। विश्वास और पारदर्शिता हमारी प्रतिबद्धता के मूल में हैं।',
    cookie_policy_title: 'BitSkins कुकी नीति: आपकी गोपनीयता हमारे लिए मायने रखती है',
    cookie_policy_description: 'BitSkins में, हम आपकी गोपनीयता को महत्व देते हैं। यह समझने के लिए कि हम कुकीज़ और इसी तरह की तकनीकों का उपयोग कैसे करते हैं, हमारी कुकी नीति पढ़ें। आपका विश्वास और डेटा सुरक्षा हमारी सर्वोच्च प्राथमिकताएं हैं।',
    docs_v1_title: 'BitSkins API V1: लीगेसी API संस्करण',
    docs_v1_description: 'निर्बाध व्यापार के लिए BitSkins API V1 को एकीकृत करें। अपनी व्यापारिक क्षमताओं को अनुकूलित करने के लिए दस्तावेज़ तक पहुंचें। नई सुविधाओं के लिए नवीनतम संस्करण में अपग्रेड करें।',
    docs_v2_title: 'BitSkins API V2: नवीनतम API संस्करण',
    docs_v2_description: 'BitSkins API V2 के साथ नई सुविधाएँ अनलॉक करें। अपनी ट्रेडिंग रणनीतियों और दक्षता को बढ़ाएँ। अभी हमारे व्यापक दस्तावेज़ देखें!',
    docs_migration_title: 'BitSkins API माइग्रेशन: नए API में निर्बाध रूप से संक्रमण',
    docs_migration_description: 'हमारे व्यापक गाइड के साथ नए BitSkins API पर सहजता से माइग्रेट करें। उन्नत ट्रेडिंग अनुभव के लिए अद्यतन सुविधाओं और एकीकरण प्रक्रियाओं का अन्वेषण करें।',
  },
  alt: {
    envelope: 'लिफ़ाफ़ा',
    app_store: 'ऐप स्टोर',
    google_store: 'गूगल स्टोर',
  },
  time: {
    seconds: 'सेकंड',
  },
  calendar: {
    week: 'सप्ताह',
    month: 'महीना',
    lifetime: 'जीवनभर',
  },
  docs: {
    docs: 'डॉक्स',
    api: 'API',
    api_v1: 'API V1 (प्रवेश द्वार)',
    api_v2: 'API V2',
    api_migration_guide: 'API माइग्रेशन गाइड',
    request_parameters: 'पैरामीटर का अनुरोध करें',
    sample_request: 'नमूना अनुरोध',
    sample_response: 'नमूना प्रतिक्रिया',
    request_schema: 'स्कीमा का अनुरोध करें',
    enums: 'एनुम्स',
  },
  wallet: {
    coupon_redeemed: 'आपने एक {amount} कूपन भुना लिया है',
    balance_changed: 'शेष राशि अद्यतन कर दी गई है',
    transfer_p2p_confirm: 'p2p.bitskins.com पर धनराशि के हस्तांतरण की पुष्टि करें',
    transfer_p2p_confirm_needed: 'आपको स्थानांतरण की पुष्टि करनी होगी',
    transfer_p2p_success: 'आपकी धनराशि p2p.bitskins.com पर स्थानांतरित कर दी गई है',
    transfer_funds: 'धनराशि का ट्रांसफर',
    deposit_started: 'जमा शुरू हो गया',
    card_removed: 'कार्ड हटा दिया गया',
    confirm_card_remove: 'क्या आप वाकई यह कार्ड हटाना चाहते हैं?',
    delete_card: 'कार्ड हटाएँ',
    deposit: 'जमा',
    withdraw: 'निकालना',
    security_code: 'सुरक्षा कोड',
    security_code_ccv: 'सुरक्षा कोड',
    card_number: 'कार्ड संख्या',
    full_name: 'पूरा नाम',
    month_expired: 'माह समाप्त (MM/YYYY)',
    addr_line_1: 'बिलिंग पता (पंक्ति 1)',
    addr_line_2: 'बिलिंग पता (पंक्ति 2)',
    zip: 'ज़िप या डाक कोड',
    city: 'शहर',
    country: 'देश',
    withdraw_only_to_visa: 'आप केवल वीज़ा कार्ड से ही धनराशि निकाल सकते हैं',
    card_country_is_restricted: 'दुर्भाग्य से, हम {country} में जारी किए गए कार्डों से निकासी की सुविधा नहीं देते हैं',
  },
  twofa: {
    required: 'दो-कारक प्रमाणीकरण आवश्यक है',
    required_for_this_payment_method: 'आप इस भुगतान विधि का उपयोग नहीं कर सकते क्योंकि आपने दो-कारक प्रमाणीकरण सेटअप नहीं किया है।',
    you_can_start_now: 'अब आप सेटअप प्रक्रिया शुरू कर सकते हैं.',
    setup: 'सेटअप 2FA',
    why_we_require: 'पढ़ने के लिए क्लिक करें - हमें निकासी के लिए 2FA की आवश्यकता क्यों है?',
  },
  password_strong: {
    minimum: 'पासवर्ड में कम से कम {value} अक्षर लंबे होने चाहिए',
    maximum: 'पासवर्ड में अधिकतम {value} अक्षर लंबे होने चाहिए',
    lowercase: 'पासवर्ड में कम से कम 1 लोअरकेस अक्षर होना आवश्यक है',
    uppercase: 'पासवर्ड में कम से कम 1 अपरकेस अक्षर होना आवश्यक है',
    numeric: 'पासवर्ड में कम से कम 1 संख्यात्मक अक्षर होना आवश्यक है',
    special: 'पासवर्ड में कम से कम 1 विशेष अक्षर होना आवश्यक है',
  },
  help_center: {
    help_center: 'सहायता केंद्र',
    hello: 'नमस्ते, हम कैसे मदद कर सकते हैं?',
    create_ticket: 'टिकट बनाएं',
    contact_us: 'संपर्क करें',
    guide: 'मार्गदर्शक',
    top_articles: 'शीर्ष लेख',
    didnt_find: 'आपको जो चाहिए वह नहीं मिला?',
    article: 'सामग्री',
    general: 'सामान्य',
    fees: 'फीस',
    buying_selling: 'खरीदना बेचना',
    deposit_withdrawal: 'जमा एवं निकासी',
    refunds: 'रिफंड',
    user_account: 'उपयोगकर्ता खाता',
    affiliate: 'संबद्ध',
    partnership: 'साझेदारी',
    scam: 'संदेहास्पद धोखाधड़ी',
    was_helpful: 'क्या यह लेख सहायक था?',
    found_helpful: '{max} में से {yes} उपयोगी पाया गया',
    faq: '<span class="color-primary">अक्सर</span> पूछे जाने वाले प्रश्नों',
  },
};
